/* eslint-disable no-template-curly-in-string */
export default {
  featured: 'Destaques',
  popular: 'Popular',
  couponsAndDeals: 'Cupons e Ofertas',
  yourFavorites: 'Seus Favoritos',
  coupons: 'Cupons',
  headerCoupons: 'Karma | Cupons',
  lastSaved: 'Últimos Salvos',
  favorites: 'Favoritos',
  trending: 'Tendência',
  weAreLoving: 'Nós adoramos',
  karmaHome: 'Karma | Casa',
  goodMorning: 'Bom dia',
  goodAfternoon: 'Boa tarde',
  goodEvening: 'Boa noite',
  addFavoriteStores: 'Adicionar Lojas Favoritas',
  nothingFound: 'Não encontrado',
  number: '{{value, number}}',
  clearNumber: '{{value, clearNumber}}',
  saveSettings: 'Salvar configurações',
  enableBrand: 'Habilitar {{name}}',
  chrome: 'Chrome',
  edge: 'Edge',
  firefox: 'Firefox',
  ie: 'Internet Explorer',
  oldEdge: 'Edge',
  opera: 'Opera',
  safari: 'Safari',
  remove: 'Remover',
  sponsored: 'Patrocinado',
  seeAll: 'Ver tudo',
  favorite: 'Favorito',
  onSale: 'Em Promoção',
  lowInStock: 'Estoque Baixo',
  backInStock: 'Voltou ao Estoque',
  coupon: 'Cupom',
  soldOut: 'Esgotado',
  fulfilled: 'Preenchido',
  deal: 'Oferta',
  price: '{{currency}}{{value, number(minimumFractionDigits: 2)}}',
  karmaStores: 'Lojas com Cash Back',
  priceLeftToWithdraw: 'Falta apenas {{currency}}{{value, number}} para retirar suas recompensas!',
  fullPrice: '{{currency}}{{value, number}}.{{fraction, fraction}}',
  fraction: '.{{value, fraction}}',
  pendingCash: 'Valor Pendente',
  payouts: 'Pagamentos',
  connectWithPayPal: 'Conectar com PayPal',
  selectCause: 'Selecione Causa',
  dayBetweenPayouts: 'Valor pode ser retirado {{count, number}} dia após confirmação da compra.',
  dayBetweenPayouts_plural: 'Valor pode ser retirado {{count, number}} dias após confirmação da compra.',
  list: 'Lista:',
  emptyWallet: 'Sua carteira está vazia',
  startShoppingToEarn: 'Compre para receber recompensas!',
  withdraw: 'Retirar',
  yourDonations: 'Suas doações',
  outOfAmount: 'Sem {{currency}}{{value, number}}',
  gettingCloser: 'Você está perto!',
  canWithdrawEarnings: 'Você já pode retirar seus ganhos.',
  workedAt: 'Trabalhou {{date}}',
  copied: 'Copiado!',
  getCoupon: 'Obter cupom',
  shopNow: 'Compre já',
  karmaLogo: 'logotipo Karma',
  stores: 'Lojas',
  myLists: 'Minhas Listas',
  uppercase: '{{text, uppercase}}',
  capitalize: '{{text, capitalize}}',
  all: 'Tudo',
  lastWeek: 'Última semana',
  lastMonth: 'Último mês',
  lastThreeMonths: 'Últimos 3 meses',
  clickID: 'ID Clique:',
  date: 'Data',
  time: 'Hora',
  retailer: 'Lojista',
  orderID: 'ID Pedido',
  startShoppingToEarnKarmaCash: 'Compre para receber Cash Back,',
  browseStores: 'explorar lojas',
  doNotHaveClicks: 'Você não teve nenhum clique neste período.',
  doNotHaveTransactions: 'Você não teve nenhuma transação neste período.',
  payPalAlt: 'PayPal',
  payPal: 'PayPal:',
  welcomeBonus: 'Bônus Boas-vindas!',
  karmaGives: 'Karma Gives!',
  karmaGivesRefund: 'Reembolso do Karma Gives!',
  completed: 'Concluído',
  notQualified: 'Não qualificado',
  pending: 'Pendente',
  cancelled: 'Cancelado',
  paid: 'Pago',
  empty: 'Vazio',
  expired: 'Expirado',
  discoverAndShop: 'Explorar e comprar',
  contactUs: 'Fale conosco',
  news: 'Novidades',
  faq: 'FAQ',
  aboutUs: 'Sobre nós',
  karmaItem: 'Item Karma',
  email: 'E-mail',
  congrats: 'Parabéns!',
  getKarmaButton: 'Obter Botão Karma!',
  saveThingsToBuy: 'Salve seus itens favoritos para comprar depois com Karma!',
  savedFirstItem: 'Você salvou o seu primeiro item!',
  getTheButton: 'Obtenha o Botão',
  savedFirstItem_plural: 'Você já salvou alguns itens!',
  iWantToSeeOther: 'Eu quero ver outras <1>lojas suportadas</1>',
  neverMissProducts: 'Fique sabendo quando produtos entrarem em promoção ou voltarem ao estoque!',
  shareByEmail: 'Compartilhar por e-mail',
  whenIFindSmth: 'Quando acho algo que quero, salvo no Karma!',
  completeSignUp: 'Concluir cadastro',
  addToList: 'Adicionar à Lista',
  chat: 'Chat',
  karmaCash: 'Cash Back',
  clickToSaveItem: 'Clique para salvar um item',
  createListAndPressEnter: 'Crie lista e aperte "Enter"',
  confirmDeleteProduct: 'Quer mesmo excluir este produto?',
  shareOnFacebook: 'Compartilhar no Facebook',
  selectAll: 'Selecionar tudo',
  selectProp: 'Selecione {{name}}',
  delete: 'Excluir',
  fulfill: 'Realizado',
  mute: 'Desativar som',
  anyPriceChange: 'Qualquer mudança de preço',
  priceOff: '{{value, number}}% de desconto',
  notifyWhen: 'Avise quando',
  tweetOnTwitter: 'Tuitar no Twitter',
  shareProduct: 'Compartilhar Produto',
  markAsFulfilled: 'Marcar como Realizado',
  unmuteNotifications: 'Ativar Áudio das Notificações',
  muteNotifications: 'Silenciar Notificações',
  priceEvolution: 'Evolução do Preço',
  logOut: 'Sair',
  twitter: 'Twitter',
  facebook: 'Facebook',
  instagram: 'Instagram',
  whatsapp: 'WhatsApp',
  messenger: 'Messenger',
  privacyPolicy: 'Política de Privacidade',
  accessibility: 'Acessibilidade',
  confirmDelete: 'Quer mesmo excluir estes produtos?',
  termsAndConditions: 'Termos e Condições',
  logosProvidedBy: 'Logos fornecidos por {{name}}',
  copyright:
    'Copyright © {{year, clearNumber}} Karma Shopping Ltd., de nome comercial Karma. Todos os direitos reservados.',
  noNotifications: 'Sem notificações',
  clearAllNotifications: 'Apagar Todas Notificações',
  areYouSureRemoveNotifications: 'Quer mesmo remover todas as notificações?',
  deleteProducts: 'Excluir Produtos',
  no: 'Não',
  yes: 'Sim',
  headerStores: 'Karma | Lojas',
  clearNotification: 'Apagar notificações',
  clear: 'Apagar',
  bell: 'sino',
  remindInMinute: 'Lembrar daqui a {{value, number}} minuto',
  remindInMinute_plural: 'Lembrar daqui a {{value, number}} minutos',
  remindInHour: 'Lembrar daqui a {{value, number}} hora',
  remindInHour_plural: 'Lembrar daqui a {{value, number}} horas',
  retailers: 'Lojistas',
  claimKarmaCash: 'Obtenha até {{percent, number}}% de Cash Back',
  clickOnClaimButton: 'Clique no botão "Obtenha até {{percent, number}}% de Cash Back".',
  goShopping: 'Vá às Compras',
  rackUpCash: 'Acumule Dinheiro',
  getPaidDirectly: 'Seja Pago Diretamente',
  earnRealMoney: 'Ganhe dinheiro de verdade de volta em literalmente todas as compras.',
  trackYourEarnings: 'Acompanhe seus ganhos e faça retiradas em todas as estações.',
  ordinalNumber: '{{value, fraction}}',
  relatedStores: 'Lojas Relacionadas',
  defaultWhatHappensNext:
    'Para ganhar Cash Back automaticamente na próxima compra, clique em um dos nossos lojistas qualificados com Cash Back no Karma, onde você pode continuar comprando como de costume! Lembre-se: você só ganha Cash Back visitando o lojista qualificado através do app ou do painel do Karma (incluindo notificações push) ou interagindo com a extensão para navegador do Karma em desktop/celular antes da compra. Depois que o lojista tiver verificado sua compra, o Karma confirmará seus ganhos na sua carteira Karma.',
  defaultTermsAndConditions:
    'Não há Cash Back na compra de cartões-presente ou em qualquer porção de uma compra que tenha sido paga com um cartão-presente, crédito de loja ou pontos de fidelidade ou outro programa de pontos. O uso de códigos promocionais não listados no site do Karma pode anular o Cash Back. Produtos ou categorias específicas podem estar sujeitas a restrições adicionais.',
  whatHappensNext: 'E agora?',
  about: 'Sobre',
  readMore: 'Leia mais',
  frequentlyAskedQuestions: 'Perguntas frequentes',
  loadMore: 'Carregar mais',
  questionButton: 'botão de interrogação',
  headerKarmaCash: 'Karma | Recompensas',
  recommended: 'Recomendado',
  highToLow: 'Maior ao menor',
  lowToHigh: 'Menor ao maior',
  sortBy: 'Selecionar por:',
  exploreStores: 'Explorar Lojas',
  weHaveNotFoundStores: 'Não encontramos nenhuma loja de acordo com sua busca',
  weHaveNotFoundCoupons: 'Não encontramos nenhum cupom de acordo com sua busca',
  headerApps: 'Karma | Aplicativos',
  karmaApps: 'Tenha um bom karma em todo lugar.',
  stayUpdated:
    'Mantenha-se atualizado(a) em qualquer aparelho. Nosso assistente de compras digitais economiza dinheiro para você em mais de {{number, number}}K lojas.',
  getFaster: 'Tenha uma experiência mais rápida e suave baixando o Karma no seu Mac.',
  headerProfile: 'Karma | Perfil',
  headerWallet: 'Karma | Carteira',
  totalBalance: 'Saldo Total',
  emailAddress: 'Endereço de E-mail',
  enterEmailAddress: 'Inserir o e-mail',
  enterEmail: 'Inserir E-mail',
  enterEmailLower: 'Inserir e-mail',
  phoneNumber: 'Celular',
  enterPhoneNumber: 'Inserir o celular',
  fullName: 'Nome Completo',
  enterFullName: 'Inserir nome completo',
  enterPlaceholder: 'Inserir {{name}}',
  birthday: 'Nascimento',
  year: 'Ano',
  month: 'Mês',
  day: 'Dia',
  gender: 'Gênero',
  language: 'Idioma',
  currency: 'Moeda',
  multiCurrency: 'Multimoeda',
  male: 'Masculino',
  female: 'Feminino',
  notWantShare: 'Não quero divulgar',
  mobilePush: 'Notificação mobile',
  webPush: 'Notificação web',
  disconnectFromPayPal: 'Desconectar do PayPal',
  loginAsUser: 'FUT',
  selectYearAndMonth: 'Selecione primeiro o ano e mês',
  notSureWhereToStart: 'Não sabe por onde começar?',
  youDidntSaveItems: 'Você ainda não salvou nenhum item.',
  searchItems: 'Buscar Itens',
  headerDashboard: 'Karma | Painel',
  headerSales: 'Karma | Ofertas',
  couldNotFindStores: 'Ops, não encontramos nenhuma venda',
  karmaGivesValue: 'U$ {{value, number}}',
  karmaGivesModalTitle: 'Aqui estão U$ {{value, number}} GRÁTIS para você começar',
  hereIsABitOfGoodKarma: 'Aqui está um karma positivo por ter se cadastrado!',
  collectAndStartSaving: 'Colecione e Comece a Economizar',
  termsAndConditionsAppersant: 'Termos e Condições',
  mayApply: 'podem ser aplicados',
  termsAndConditionsError: 'Primeiro, concorde com os nossos termos e política de privacidade.',
  validEmailError: 'Digite um e-mail válido.',
  completeSignUpCapital: 'Concluir Cadastro',
  or: 'OU',
  password: 'Senha',
  joinUs: 'Junte-se a nós',
  reviewsPlus: '{{amount, number}}k+ avaliações',
  logIn: 'Entrar',
  termsAgreement: 'Ao se cadastrar, você concorda com nossos <1>Termos</1> e nossa <3>Política de Privacidade</3>',
  termsAgreementWithCheckbox: 'Eu concordo com os <1>Termos e Condições</1> e com a <3>Política de Privacidade</3>',
  createANewList: 'Criar Nova Lista',
  listCreateBlickError: 'Nome da lista não pode estar em branco',
  enterListName: 'Digite um nome da lista',
  listDescriptionOptional: 'Descrição da Lista (opcional)',
  listName: 'Nome da Lista',
  enterDescriptionForList: 'Inserir descrição da lista',
  save: 'Salvar',
  deleteList: 'Excluir Lista',
  areYouSureRemoveList: 'Quer mesmo remover esta lista?',
  editList: 'Editar Lista',
  listNameCanNotBeBlanck: 'Nome da lista não pode estar em branco',
  shareList: 'Compartilhar Lista',
  notAMemberCreateAccount: 'Não tem conta? <1>Criar conta!</1>',
  backToLogin: 'Voltar ao login',
  enterYourEmail: 'Inserir e-mail',
  resetPassword: 'Redefinir Senha',
  forgotPasswordMessage: 'Em alguns minutos, você receberá um e-mail com instruções sobre como redefinir sua senha.',
  forgotPassword: 'Esqueceu a Senha?',
  pleaseScan: 'Favor buscar',
  saveAnItem: 'Salvar um item',
  areYouSureFulfilled: 'Quer mesmo marcar estes produtos como concluídos?',
  muteTagDesc: 'Quer mesmo silenciar as notificações destes produtos?',
  muteTagTitle: 'Silenciar Notificações',
  ok: 'OK',
  ccpaTitle:
    'Lei de Privacidade do Consumidor da Califórnia (CCPA), conforme alterado pela Lei de Direitos de Privacidade da Califórnia (CPRA)',
  ccpaText:
    ' Ao enviar este formulário, eu exerço meu direito de recusar qualquer venda de minhas informações pessoais.',
  submit: 'Enviar',
  joinKarmaAndGetRewards: 'Entre no Karma e ganhe {{stake, number}} recompensas em {{name}}',
  doNotMissOut: 'Não perca. Você pode economizar neste produto!',
  signUpAndGetMoney: 'Inscreva-se e receba U$ {{value, number}}',
  itemAlert: 'Há um Alerta de Item!',
  accessKarmaCash: 'Acesse seu Cash Back',
  youEarnedKarmaCash: 'Você acaba de ganhar Cash Back!',
  weHaveSentAnEmailTo: 'Enviamos um e-mail para',
  'Fall Favorites': 'Favoritos do Outono',
  'Karma Cash': 'Cash Back',
  'Clothing & Luxury': 'Vestuário e Luxo',
  'Home Decor & Furniture': 'Decoração e Móveis',
  'Electronics & Office Supplies': 'Eletrônicos e Escritório',
  Luxury: 'Luxo',
  Clothing: 'Roupas ',
  'Handbags & Shoes': 'Bolsas e Sapatos',
  'Jewelry & Watches': 'Joias e Relógios',
  Accessories: 'Acessórios',
  'Beauty Essentials': 'Essenciais de Beleza',
  'Health & Wellness': 'Saúde e Bem-estar',
  Lifestyle: 'Estilo de Vida',
  'Sports & Outdoors': 'Esportes e Ar Livre',
  Travel: 'Viagem',
  'Electronics & Office supplies': 'Eletrônicos e Escritório',
  'Entertainment & Online Services': 'Entretenimento e Serviços On-line',
  Education: 'Educação',
  'Finance & FinTech': 'Finanças e FinTech',
  'Pet Supplies': 'Pets',
  'Food & Beverages': 'Comidas e Bebidas',
  Men: 'Homem',
  Women: 'Mulher',
  Unisex: 'Unissex',
  Kids: 'Infantil',
  Baby: 'Bebê',
  notifications: 'Notificações',
  changesSaved: 'Alterações salvas!',
  headerRetailer: 'Karma | Lojista',
  headerRedirect: 'Karma | Redirecionando...',
  karma: 'Karma',
  goBackToKarma: 'Voltar ao Karma',
  authentication: 'Autenticação',
  authSuccess: 'Parabéns! Você fez login com sucesso.',
  authFailure: 'Ops, não pudemos autorizá-lo. Tente mais tarde.',
  mayNotQualify: 'Alguns produtos não são qualificados para Cash Back',
  checkOutRetailers: 'Confira nossos lojistas que aceitam Cash Back.',
  headerHowItWorks: 'Karma | Como Funciona',
  accept: 'Aceitar',
  headerError: 'Karma | Erro',
  pageNotFound: 'Página Não Encontrada',
  pageDoesNotExist: 'Ops, esta página não existe.',
  backHome: 'Voltar para Início',
  startShopping: 'Começar a Comprar',
  illustration: 'Ilustração',
  dashboard: 'Painel de Controle',
  allRightsReserved: 'Todos os direitos reservados.',
  product: 'Produto',
  disclaimer:
    'Karma Shopping Ltd., de nome comercial Karma. A Karma não possui nem pretende possuir a propriedade de marcas registradas de terceiros. As marcas registradas de terceiros que estejam visíveis ou acessíveis, direta ou indiretamente, pela plataforma Karma, não necessariamente têm uma relação com a Karma, com seus associados terceirizados ou com os provedores de serviços da Karma.',
  help: 'Ajuda',
  team: 'Equipe',
  howItWorks: 'Como funciona',
  supportedStores: 'Lojas Parceiras',
  company: 'Empresa',
  planYourPurchase: 'Planeje sua próxima compra com nosso app gratuito!',
  itSitsInBrowser: 'Ele fica no seu navegador enquanto você explora suas lojas favoritas.',
  seeSmthYouLike:
    'Viu algo que gostou? Clique no botão para salvar na sua lista e o Karma vai acompanhar o preço e a disponibilidade para você.',
  youWillGetNotified:
    'Você será notificado(a) instantaneamente quando algum dos seus produtos entrar em promoção, baixar o preço ou voltar ao estoque na sua cor e tamanho de preferência.',
  everythingYouWant:
    'Tudo que você quiser comprar estará em um lugar conveniente, para que possa se organizar e parar de lidar com várias listas de desejos.',
  headerContactUs: 'Karma | Contate-nos',
  needToGetInTouch: 'Quer entrar em contato?',
  dropALine: 'Entre em contato',
  comeHangOut: 'Enturme-se conosco',
  joinOurFacebookCommunity: 'Entre na nossa comunidade do Facebook',
  followOnInstagram: 'Siga-nos no Instagram',
  headerAboutUs: 'Karma | Sobre Nós',
  addTheItems:
    'Adicione os produtos que está comprando — você pode personalizar até o tamanho e a cor — e o app notificará você quando ele entrar em promoção.',
  jonathanSay:
    'Jonathan: Enquanto os lojistas têm usado IA por anos, agora é o cliente que aproveita o aprendizado de máquina e as ferramentas de automação para ter mais eficiência.',
  justDownload:
    'É só baixar um "botão" e clicar nele quando estiver em um produto que quiser salvar na lista. No celular, você pode "compartilhar" produtos diretamente com as mesmas listas.',
  ifYouFind:
    'Se você encontrar um produto on-line fora do orçamento, você pode definir um alerta de promoção para ser notificado(a) quando o preço baixar.',
  onlyAHandful: 'Poucas empresas que oferecem alertas de promoção ainda existem, incluindo a Karma.',
  alwaysBuy: 'Compre algo sempre na promoção com Karma',
  headerCareers: 'Karma | Carreiras',
  getInTouch: 'Entre em contato conosco.',
  shop: 'Loja',
  weCouldNotFindResults: "Não encontramos resultados para '{{name}}'",
  couldNotFindResults: 'Não encontramos nenhum resultado',
  shopAllStores: 'Compre em todas as lojas parceiras',
  popularStores: 'Lojas populares',
  shops: 'Lojas',
  headerDiscoverAndShop: 'Karma | Descubra e compre os últimos produtos salvos',
  prev: 'Anterior',
  next: 'Próximo',
  headerDemo: 'Karma | Demo',
  getTheKarmaButton: 'Obtenha o Botão Karma',
  installedKarma: 'Você instalou o Karma com sucesso!',
  settingUpAccount: 'Agora, vamos começar configurando sua conta.',
  signUpNow: 'Inscreva-se agora',
  logInNow: 'Entre agora',
  signUpLater: 'Inscreva-se depois',
  wePartnerWith: 'Fazemos parcerias com mais de {{number, number}}K+ lojas on-line!',
  pickStoresToSee: 'Escolha uma das lojas abaixo para ver como funciona:',
  leaveKarma: 'Note que você deixará o Karma e irá para a página da loja para uma experiência completa.',
  searchFavoriteStores: 'Busque Suas Lojas Favoritas',
  clickBelowToStart: 'Clique abaixo para começar',
  chooseOneOfTheOptions: 'Escolha uma das opções abaixo',
  clickToBegin: 'Clique na barra de busca para começar',
  preferNotToSay: 'Prefiro não informar',
  done: 'Concluído',
  headerUnsubscribe: 'Karma | Cancelar Inscrição',
  changeMind: 'Mudou de ideia?',
  resubscribeList: 'Recadastrar na lista de envios.',
  resubscribeList_plural: 'Recadastre na lista de envios aqui.',
  changePreferencesAtAnyTime: 'Você também pode suas preferências a qualquer momento nas<1>configurações de conta.</1>',
  preferencesUpdated: 'Atualizamos suas preferências de e-mail.',
  sorryToSeeYouGo: 'Sentiremos sua falta!',
  reSubscribed: 'Você se recadastrou',
  allowHours: 'Favor aguardar até {{hours, number}} horas para que as mudanças tenham efeito.',
  missWhenYouGone:
    'Sentiremos sua falta! Favor aguardar até {{hours, number}} horas para que as mudanças tenham efeito.',
  headerDisablingSubscribe: 'Karma | Cancelando Inscrição',
  noLongerAlerts: 'Você não receberá mais alertas para este produto.',
  turnAlertsBack: 'Reativar os alertas.',
  moveAnimations: 'Animação de movimento do botão',
  headerExtensionDeleted: 'Karma | Extensão excluída',
  areSorryToSeeYouGo: 'Sentimos muito por ver você partir!',
  youHaveGotInYourWallet: 'Você tem U$ {{value}} na sua Carteira.',
  toWithdraw: ' para retirar seus ganhos!',
  toContinue: ' para continuar ganhando recompensas!',
  reasonUninstalled: 'Por favor, conte-nos por que você desinstalou:',
  getInTouchBtn: 'Entre em contato',
  howWeCanIncrease: 'Você pode aumentar seu reconhecimento e impulsionar vendas anunciando no Karma destas formas',
  helpingShoppers:
    'Ajudando compradores a descobrirem marcas que eles vão amar é uma de nossas maiores prioridades como um assistente de compras pessoal.',
  whyWeOfferBrands:
    'É por isso que oferecemos às marcas que consistentemente entregam uma alta satisfação do cliente várias formas de se conectarem com nosso público. Você atinge as metas de sua campanha e nossa clientela conhece sua nova marca favorita.',
  winWin:
    'Nós oferecemos às marcas que consistentemente entregam uma alta satisfação do cliente várias formas de se conectarem com nosso público. Você atinge as metas de sua campanha e nossa clientela conhece sua nova marca favorita — todo mundo ganha!',
  getFeaturedRight: 'Apareça em destaque no nosso app e no painel da extensão do navegador',
  getFeaturedDashboard: 'Apareça em destaque no painel do Karma',
  putYourHand:
    'Tenha presença, produtos ou promoções no lugar exato para onde nossos usuários vão quando estão prontos para comprar. Podemos criar vários conteúdos de marca para promover o tráfego para onde você precisa que ele vá.',
  exactPlace: 'Coloque sua marca no lugar exato em que nossos usuários vão quando querem comprar.',
  dedicatedInAppPlacement: 'Posicionamento dedicado no aplicativo',
  dashboardFeaturedBanners: 'Banners em Destaque do Painel',
  dashboardPopUpMessages: 'Mensagens Pop-Up do Painel',
  customEmailsAndNewsLetters:
    'Customize e-mails e o posicionamento em informativos para {{subscribers, number}}+ inscritos',
  customEmails: 'Customize E-mails para {{subscribers, number}}+ Inscritos',
  getMoreEyes:
    'Chame mais atenção para sua última oferta, código de cupom ou linha de produtos com um e-mail ou posicionamento dedicado em informativos para compradores.',
  putYourBrand: 'Coloque sua marca no lugar exato em que nossos usuários vão quando querem comprar.',
  newsletterInclusion: 'Inclusão no Informativo',
  dedicatedCustomEmails: '{{percent, number}}% de E-mails Personalizados Dedicados',
  bannerPlacementInEmails: 'Posicionamento de Banner nas Notificações por E-mail',
  pushNotificationsToShoppers: 'Notificações push para {{shoppers, number}}+ compradores',
  pushNotificationsGiveTouchPoint:
    'As notificações push dão à sua campanha outro ponto de interação e promovem altas taxas de cliques e acessos.',
  featureBrandClients: 'Marcas em Destaque',
  growingPerMonth: 'Crescendo +{{number, number}}k por mês',
  members: 'Membros',
  percent: '{{value, number}}%',
  kindOfReachYouExpect: 'Que tipo de alcance você espera?',
  ourAudience: 'Nosso Público',
  tabIntoNewSource: 'Acesse uma nova fonte de clientes qualificados para sua próxima campanha',
  tellUsAboutYourCompany:
    'Conte-nos um pouco sobre sua empresa e suas metas e mostraremos como podemos ajudar você a superá-las.',
  openAndTap: 'Abra o Safari e vá à página do produto que você deseja salvar e clique no botão "Compartilhar"',
  shareIllustration: 'Compartilhar ilustração',
  tapMore: 'Clique no botão "Mais" no lado direito do painel.',
  moreIllustration: 'Mais ilustração',
  enableIllustration: 'Habilitar ilustração',
  tapEdit: 'Clique no botão "Editar" no topo do painel.',
  enableApp:
    'Habilite o Karma e clique no botão "adicionar" para adicioná-lo aos seus Favoritos e, então, clique em "Pronto".',
  goBackToTheProduct:
    'Volte à página do produto, clique no botão "Compartilhar" e, então, clique no botão "Karma" para salvar o produto.',
  recommendedBy: 'Recomendado por',
  ourMembersSavingMoney: 'Nossos compradores ❤️ economizar com o Karma. Aqui estão os motivos.',
  ourMembersSavingMoney2: 'Nossos compradores <1/> economizar com o Karma. Aqui estão os motivos.',
  addToBrowser: 'Adicione ao {{browser}} - É gratuito',
  planPurchases: 'Planeje suas próximas compras',
  karmaMakesItEasy: 'Com Karma fica fácil organizar suas próximas compras em um só lugar.',
  buyAtRightTime: 'Compre na hora certa',
  automaticallyAlert: 'Karma te avisa automaticamente quando é a hora certa de comprar.',
  cashOnVacation: 'Cash Back em suas próximas férias',
  karmaPartners: 'Parceiros Karma com vários sites de viagens e hotéis',
  headerRewards: 'Karma | Melhores Cupons e Recompensas Financeiras',
  mission: 'Nossa Missão',
  empowerYou: 'Ajudar você a tomar a decisão certa na hora certa quando comprar on-line.',
  weAreSeriousAboutPrivacy: 'Nos preocupamos com a sua privacidade e segurança',
  weDoNotSellData: 'Não vendemos os seus dados',
  karmaIsSerious: 'O Karma se preocupa com seus dados e nunca os venderemos para terceiros. Nunca.',
  karmaIsSecure: 'Karma é seguro',
  weUseBankSecurity:
    'Nós usamos segurança de nível bancário (criptografia de {{bit, number}}-bits) para garantir que seus dados estejam seguros e protegidos.',
  helpsSaveMore: 'Karma te ajuda a economizar!',
  alertMe: 'Alerte-me',
  buyWithKarmaEarn: 'Compre com Karma - Ganhe U$ {{number, number}}',
  productSaved: 'Parabéns! Este produto foi salvo na sua lista de itens. Você será notificado quando o preço cair.',
  willApplyTheBestCoupons: 'O Karma aplicará automaticamente o melhor cupom para sua compra!',
  downloadAndAutoApply: 'Baixe o Karma e Aplique Automaticamente',
  whatIsKarma: 'O que é o Karma?',
  claimUpToRewards: 'Ganhe até {{number, number}}% de Recompensas em Dinheiro',
  youMightAlsoLike: 'Você talvez goste',
  weAreSorry: 'Desculpe, algo deu errado e a página não pode ser exibida.',
  tryToReloadPage: 'Por favor, tente recarregar a página.',
  Color: 'Cor',
  Size: 'Tamanho',
  latestCoupons: '{{name}} | Últimos Cupons e Cashback do Karma em {{year, clearNumber}}',
  neverPayFullPrice: 'Não pague mais o preço cheio. Encontre Cupons e Cashback do Karma para {{name}}',
  neverPayFullPriceForTag: 'Nunca mais pague o preço cheio por {{name}}',
  saveMoneyWhenShoppingAt: 'Economize Dinheiro Ao Comprar Na {{name}}. Cadastre-se no Karma Gratuitamente',
  saveMoneyWhenShoppingFor: 'Economize Dinheiro Ao Comprar {{name}}. Cadastre-se no Karma Gratuitamente',
  tagByBrand: 'Karma | {{tag}} por {{brand}}',
  typeToSearch: 'Digite para pesquisar',
  getUSDWhenJoinToday: 'Receba U$ {{value, number}} Cadastrando-se no Karma Hoje!',
  buyProduct: 'Comprar Produto',
  userWishList: 'Karma | lista de compras {{name}}',
  byWhom: 'por',
  copiedToClipboard: 'Copiado para a área de transferência!',
  send: 'Enviar',
  cause: 'Selecione a causa:',
  aCause: 'Selecione uma causa:',
  close: 'Fechar',
  selectThisCause: 'Selecionar esta causa',
  habitatForHumanity:
    '{{name}} concentra-se na redução da pobreza no longo prazo através de moradias sociais acessíveis. Sua missão é construir um ambiente seguro, onde famílias e comunidades possam prosperar',
  casaDescription:
    'A National CASA/GAL Association apoia e promove advocacia voluntária designada por tribunal de modo que toda criança que tenha sofrido abuso ou negligência possa ficar segura, ter um lar permanente e a oportunidade de prosperar',
  endHomelessnessDescription:
    'A Aliança Nacional para {{name}} é uma organização não governamental determinada a prevenir e eliminar a falta de habitação nos Estados Unidos',
  pathDescription: 'PATH está ajudando pessoas, famílias e comunidades sem habitação a encontrar abrigo',
  feedingAmericaDescription: 'Feeding America é a maior organização nacional de combate à fome',
  mealsOnWheelsDescription:
    '{{name}} capacita programas comunitários locais a melhorar a saúde e a qualidade de vida dos idosos que atendem para que nenhum tenha fome ou fique isolado',
  actionAgainstHunger:
    '{{name}} é uma organização humanitária global que toma medidas decisivas contra as causas e efeitos da fome',
  supportMedicalAdvancement: 'Apoio ao avanço médico',
  saveChildsHeartDescription:
    "Save A Child's Heart presta serviços de saúde do coração, independentemente de raça, religião, gênero, nacionalidade ou situação financeira",
  su2c: 'Stand Up To Cancer (SU2C) financia e desenvolve os tratamentos de câncer mais modernos e promissores para ajudar pacientes',
  drWithoutBorders: '{{name}} é um movimento global independente que presta auxílio médico onde é mais necessário',
  activeMinds:
    '{{name}} é a principal organização sem fins lucrativos do país, que promove conscientização de saúde mental e educação para jovens adultos',
  cleanAirTaskForceDesc:
    '{{name}} estimula mudanças necessárias em tecnologias e políticas para chegar a um planeta com zero emissão e alta energia a um custo acessível',
  wwfDesc:
    'A missão da {{name}} é preservar a natureza e reduzir as ameaças mais urgentes à diversidade da vida na Terra',
  waterkeepsDesc:
    '{{name}} luta por água limpa. A Waterkeeper Alliance trabalha para garantir que toda comunidade ao redor do mundo tenha água potável, própria para pescar e nadar',
  xprice:
    'Todos os dias, a XPrize trabalha para criar um mundo melhor onde todos tenham acesso a água limpa, alimentos nutritivos, moradia acessível, educação eficaz, cuidados médicos da melhor qualidade e energia abundante não poluente',
  globalActDesc: '{{name}} trabalha para pôr um fim à exploração sexual e comercial',
  pcaa: '{{name}} trabalha duro para concretizar nossa visão de um mundo onde todas as crianças cresçam felizes, saudáveis e preparadas para ter sucesso em famílias e comunidades solidárias',
  endCAN:
    'A EndCAN promove a conscientização dos impactos do abuso na saúde física, mental e pública, com a missão de pôr um fim no abuso e negligência infantis',
  futuresDesc:
    'FUTURES oferece programas, políticas e campanhas inovadores que capacitam pessoas e organizações trabalhando para eliminar a violência contra as mulheres e as crianças ao redor do mundo',
  thornDesc: '{{name} constrói tecnologias para defender crianças do abuso sexual.',
  'Eradicate Homelessness': 'Erradicar a falta de habitação',
  'Help End Hunger': 'Ajudar a eliminar a fome',
  'Support Medical Advancement': 'Promover o avanço médico',
  'Combat Climate Change': 'Combater as mudanças climáticas',
  'Act To End Abuse': 'Agir para eliminar o abuso',
  itemsYouSaved: 'Itens salvos por menos',
  beta: 'BETA',
  alsoAvailableAt: 'Disponível também em',
  atName: 'em {{name}}',
  bestPrice: 'Melhor Preço',
  passwordWasSuccessfullyReset: 'A senha foi redefinida',
  paidWith: 'Pago com',
  infoFirstNumber: '{{number, number}}{{unit}}+',
  infoFirstTitle: 'Membros',
  infoSecondNumber: '{{number, number}}{{unit}}+',
  infoSecondTitle: 'Visitas Mensais',
  infoThirdNumber: '{{number, number}}{{unit}}+',
  infoThirdTitle: 'Lista de E-mail',
  infoFourthNumber: '{{value, number}}%',
  infoFourthTitle: 'Millenials',
  infoFifthNumber: '{{value, number}}%',
  infoFifthTitle: 'Feminino',
  infoSixthNumber: '{{value, number}}%',
  infoSixthTitle: 'Localizado nos EUA',
  infoSeventhNumber: '{{number, number}}{{unit}}+',
  infoSeventhTitle: 'Permitir notificações push no celular',
  infoEighthNumber: '{{number, number}}{{unit}}+',
  infoNinthPreNumber: '',
  infoNinthNumber: '${{number, number}}{{unit}}+',
  infoNinthTitle: 'Serão usados pelos usuários até o fim de {{year, clearNumber}}',
  karmaIsAlwaysWithYou: 'O Karma está sempre com você nas compras',
  saveItemsToBuy: 'Salves itens e vamos te dizer quando comprar',
  weDoTheWork: 'Fazemos o trabalho para encontrar os melhores cupons',
  earnRealCashThatAdds: 'Ganhe dinheiro real que se acumula na sua carteira',
  setUpStrongPassword: 'Defina uma senha forte',
  settingEmailAccount:
    'A última etapa para economizar com Karma? Cadastre-se para podermos te enviar alertas importantes sobre os seus Itens, como promoções.',
  settingPasswordAccount:
    'A senha deve conter no mínimo {{number, number}} caracteres e não deve incluir suas credenciais de e-mail.',
  countWaysToUse: '{{number, number}} jeitos de usar Karma',
  goBack: 'Voltar',
  pleaseChooseStrongerPassword: 'Escolha uma senha mais segura',
  pleaseEnterValidEmailAddress: 'Insira um endereço de e-mail válido',
  illSignUpLater: 'Inscrever-se depois',
  joinOur1MEarningUsers: 'Join our 1M earning users',
  enterYourEmailAddress: 'Insira seu e-mail e lhe enviaremos um link para redefinir sua senha.',
  headerOnboardingIosExtension: 'Karma | Extensão Integração IOS',
  weWillAutomaticallyApplyCouponsWhereverYouShop: 'Aplicaremos cupons automaticamente onde quer que você compre',
  continue: 'Continuar',
  changeLanguage: 'Mudar Idioma',
  selectedLanguage: 'Idioma Selecionado',
  headerMuteItem: 'Karma | Desativar Item',
  itemHasBeenMuted: 'Este item foi desativado.',
  toUnmuteItem: 'Ativar som deste item:',
  headToMyItems: 'Vá para a guia "Meus itens"',
  openKarma: 'Abrir',
  clickThreeButtonsInItem: 'Clique nos três botões no canto inferior direito do item',
  clickUnmute: 'Clique no item que pretende ativar o som',
  changeNotification: 'Alterar as configurações de notificação sob o preço do item',
  weveJustRaisedInFunding:
    'Arrecadamos ${{value, number}}M de financiamento série A para ajudá-lo a comprar com inteligência!',
  weveJustRaised: 'Arrecadamos ${{value, number}}M',
  landingReview1: 'Ótimo app! Fui avisado sobre uma promoção e economizei muito!',
  landingReview2: 'Economizei ${{value, number}} logo na primeira compra. Impressionante!',
  landingReview3: 'Um app muito útil; amo os alertas e recompensas.',
  landingReview4: 'Ainda não vi nenhuma outra experiência de compra melhor!',
  landingReview5: 'Poupei {{value, number}}%! Não saberia sobre a promoção se não fosse ele!',
  landingReview6: 'Fácil seguir produtos que você adora... Superrecomendado...!',
  landingReviewAuthor1: 'Justin Nguyen',
  landingReviewAuthor2: 'Amy Ellis',
  landingReviewAuthor3: 'Maude Aethelredd',
  landingReviewAuthor4: 'Patrick Slocum',
  landingReviewAuthor5: 'Michelle Findley',
  landingReviewAuthor6: 'Varsha Hulekal',
  auxiliaryDate: '{{date}}',
  resetMyPassword: 'Redefinir minha senha',
  repeatPassword: 'Repetir senha',
  continueAsGuest: 'Continuar como visitante',
  viewAt: 'Visualizar em {{- name}}',
  signUp: 'Inscrever-se',
  youMayAlsoLike: 'Você pode gostar de',
  buyOnShop: 'Compre em',
  viewOn: 'Ver em {{- name}}',
  quickView: 'Olhada rápida',
  newList: 'Nova lista',
  undo: 'Desfazer',
  productDeleted: 'Produto excluído',
  linkCopiedToClipboard: 'Texto copiado',
  wishlists: 'Desejados',
  headerPartnerships: 'Karma | Parcerias',
  letsJoinForces: 'Vamos unir forças',
  bePartOfTheSmartShoppingRevolution:
    'Junte-se à revolução das compras inteligentes. Colocaremos sua marca em frente a +de {{number, number}} milhões de compradores prontos para finalizar a compra.',
  seeKarmaInAction: 'Veja Karma em ação',
  discoverHowKarma:
    'Como soluções baseadas na automação e IA do Karma podem aprimorar compras, direcionando tráfego específico para suas ofertas.',
  stepUpYourSales: 'Aumente suas vendas',
  averageROAS: 'ROAS<br/>médio',
  increaseInAOV: 'Aumento<br/>no AOV',
  useKarmaToPlanTheirNextPurchase: 'Use Karma e planeje<br/>suas próximas compras',
  meetOurShoppers: 'Conheça nossos compradores',
  meetOurShoppersDescription:
    'Aproveite soluções de marketing orientadas ao desempenho e fidelize compradores com alta intenção de compra. Use nossas colocações multiplataforma e alcance usuários onde estiverem.',
  audienceInfoFirstNumber: '{{number, number}}{{unit}}+',
  audienceInfoFirstTitle: 'Usuários',
  audienceInfoSecondNumber: '{{number, number}}{{unit}}+',
  audienceInfoSecondTitle: 'Visitas mensais',
  audienceInfoThirdNumber: '{{number, number}}{{unit}}+',
  audienceInfoThirdTitle: 'Itens salvos',
  audienceInfoFourthNumber: '{{value, number}}%',
  audienceInfoFourthTitle: 'Usuários nos EUA',
  audienceInfoFifthNumber: '{{value, number}}%',
  audienceInfoFifthTitle: 'Gerações Z e Y',
  audienceInfoSixthNumber: '{{value, number}}%',
  audienceInfoSixthTitle: 'Compradoras',
  ourUsersLoveUs: 'Nossas usuárias nos amam!',
  partnershipsReview1:
    'Uma ótima extensão! Sou usuária há anos e é ótimo poder salvar um monte de produtos num só lugar - torna as compras on-line muito menos estressantes!',
  partnershipsReviewAuthor1: 'Mirna Ramos',
  partnershipsReview2:
    'Como alguém que compra de tudo on-line, digo honestamente que o Karma é o melhor amigo dos compradores por vários motivos...',
  partnershipsReviewAuthor2: 'Sandra Maria',
  partnershipsReview3:
    'Melhor app de compras na PlayStore. Tão fácil de usar. Salvo todos os meus itens de minhas lojas favoritas num só app! 👍🏻',
  partnershipsReviewAuthor3: 'Cecília Ribeiro',
  performanceBasis: 'Desempenho básico',
  fixedFee: 'Taxa fixa',
  thanksForSubmitting: 'Obrigado por enviar!',
  someoneFromOurPartnershipsTeamWillBeInTouchShortly: 'Nossa equipe de parcerias entrará em contatado em breve.',
  letsKickStartOurPartnership: 'Vamos iniciar nossa parceria!',
  emailOrPhoneNumber: 'E-mail ou telefone',
  retailerName: 'Varejista indicado',
  affiliateNetwork: 'Rede afiliada',
  budgetStructure: 'Estrutura orçamentária',
  budget: 'Orçamento',
  tellUsMore: 'Conte-nos mais',
  pleaseFillInAllRequiredFields: 'Preencha os campos obrigatórios',
  partnerships: 'Parcerias',
  weCannotSaveThisItem: 'Não podemos salvar este item <1/> pois essa loja não é aceita',
  theresCoupon: 'Tem um cupom!',
  yourItemIsOffWithCode: 'Seu item está com {{value, number}}% de desconto com o código {{code}} em {{- name}}.',
  muteAllNotification: 'Silenciar todas as notificações',
  unMuteAllNotification: 'Reativar áudio das notificações',
  notificationSettings: 'Configurações das notificações',
  deleteNotification: 'Excluir notificação',
  notificationDeleted: 'Notificação excluída',
  itemMuted: 'Item silenciado',
  itemUnMuted: 'Áudio reativado',
  priceDrop: 'Queda de preço',
  superDeal: '🔥 Superoferta',
  notSureWhenToBuy: 'Não sabe quando comprar? Crie uma conta gratuita e vamos lhe dizer quando houver uma promoção.',
  tcMayApply: 'Sujeito a T&Cs',
  earnKarmaCash: 'Ganhe até {{percent, number}}% de Cash Back.',
  saveToKarma: 'Salvar item no Karma',
  getKarmaToTrackItem: 'Obtenha o Karma para acompanhar o tem',
  itemSaved: 'Item salvo!',
  youCanNowFindItem: 'Você já pode encontrar o item no seu Painel do Karma.',
  getKarmaExtension: 'Baixe a extensão do Karma para <1/> acompanhar este item imperdível',
  notifyYou: 'Vamos avisar quando for a melhor hora de comprar!',
  downloadTheExtension: 'Baixar a extensão',
  outOfStock: 'Esgotado',
  invalidEmailError: 'E-mail inválido',
  collapse: 'Recolher',
  expand: 'Expandir',
  lists: 'Listas',
  organizeYourItemsIntoWishListsWithJustAClick: 'Organize seus itens em listas de desejos com apenas um clique.',
  newItem: 'Novo item',
  helpCenter: 'Central de Ajuda',
  priceHighToLow: 'Preço Maior para Menor',
  priceLowToHigh: 'Preço Menor para Maior',
  sale: 'Promoção',
  filterBy: 'Filtrar por:',
  karmaExclusive: 'Exclusivo do K',
  noItemsFound: 'Nenhum item encontrado',
  select: 'Selecione',
  likeSneakersOrBlackFriday: "Como 'Tênis' ou 'Black Friday'",
  updateList: 'Atualizar lista',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  enterFirstName: 'Digite o nome',
  enterLastName: 'Digite o sobrenome',
  recentSearches: 'Pesquisas recentes',
  addYourFavoriteStores: 'Adicione suas lojas favoritas',
  toAccessTheirLatestCoupons: 'para acessar os cupons mais recentes',
  logosProvidedByClearbit: 'Logotipos fornecidos pela Clearbit',
  dateOfBirth: 'Data de nascimento',
  weHaveEmailedYouALinkToResetYourPassword: 'Enviamos um link por e-mail para redefinir sua senha.',
  didNotGetIt: 'Não recebeu?',
  profile: 'Perfil',
  promotionsAndActivity: 'Promoções e atividades',
  couponsForFavoriteStores: 'Cupons para lojas favoritas',
  accountActivity: 'Atividade da conta',
  powerShopper: 'Comprador power? 💪',
  enterLinkToAnyItemPage: 'Digite um link para qualquer página de item',
  saveStuffWithZeroFuss: '<0>Baixe a extensão de navegador </0> e salve coisas sem complicações.',
  viewMore: 'Ver mais',
  tooHotToMiss: 'Top demais para perder',

  // WebsiteLandingKarmaOld
  joinShoppers: 'Junte-se a mais de {{number, number}} milhões de compradores',
  waysToUse: 'Formas de usar o Karma',
  youCanUseKarma:
    'Você pode usar o Karma de várias formas, como se certificar de conseguir o melhor preço na hora certa, além de planejar suas próximas compras. Aqui estão alguns exemplos que recomendamos:',
  livesInBrowser: 'Karma fica no seu navegador',
  browserExtension: 'A extensão do Karma vai com você onde você fizer compras on-line.',
  helpsYouPlan: 'Ajuda a planejar suas próximas compras',
  notReadyToBuyJust:
    'Não quer comprar agora? Salve para mais tarde com a extensão de navegador Karma e compre com mais consciência. Você pode acompanhar todos os itens salvos em um só lugar. ',
  automaticallyFindsCouponCodes: 'Encontra cupons automaticamente',
  findsAndAppliesCodes:
    'O Karma encontrará e aplicará automaticamente o melhor cupom para que você tenha sempre o melhor valor.',
  soYouCanBuyAtTheRightTime: 'Para que você possa comprar na hora certa',
  usesCleverTechnologies:
    'O Karma usa tecnologia inteligente que monitora a queda dos preços ou quando a peça volta ao estoque, assim você pode comprar na hora certa. ',
  notOnlySave:
    'Além de ajudar a economizar, O Karma também faz você ganhar dinheiro! Sem pontos. Sem truques. Você pode ganhar dinheiro real sempre que comprar algo.',
  makeImpact: 'Cause um impacto!',
  donate:
    'Compre como costuma comprar e veja como o Karma retribui. A cada compra de mais de U$ {{over, number}}, doamos U$ {{dollars, number}} a uma causa da sua escolha.',
  accessToOffers: 'Acesso a ofertas exclusivas',
  accessItems:
    'Acesse seus itens salvos no mesmo lugar, descubra ofertas exclusivas e veja as tendências no mundo com o Karma.',
  hereIsHowItWorks: 'Como funciona',
  learnMoreAboutGives: 'Saiba mais sobre o Karma Gives',
  alwaysKnowWhenPricesDrop: 'Fique por dentro das promoções',
  getNotifiedWhenBackInStock: 'Seja avisado quando voltar ao estoque',
  findsYouBestCoupons: 'Encontre os melhores cupons',
  getKarmaCashWhenYouShop: 'Use Cash Back ao fazer compras',
  easilySaveAllThings: 'Economize em seus itens favoritos {{value, number}} em milhares de lojas',
  karmaProvidesGreatTechnology:
    'Karma oferece tecnologia de ponta e flexibilidade para comprar com inteligência, evitar compras impulsivas desnecessárias e economizar seu tempo e dinheiro.',

  accountActivityAndImportantInformation: 'Atividade da conta e informações importantes',
  addKarmaToYourDesktop: 'Adicione Karma ao desktop para poder comprar<br/>durante o horário de trabalho.',
  addNumberItemsToList: 'Adicionar {{value}} itens à lista',
  addOneItemToList: 'Adicionar 1 item à lista',
  addStuffYouFindToThisListToKeepItOrganized:
    'Adicione a esta lista coisas que você encontrar para mantê-la organizada.',
  alrightBut: 'Tudo bem, mas você vai passar um FOMO absurdo!',
  areYouSureYouWantToDisconnectFromPaypal: 'Quer mesmo se desconectar do Paypal?',
  balance: 'Saldo',
  buyWhateverYouWant: 'Compre o que quiser e deixe a mulher do banco feliz.',
  cashIsBack: '<1>Dinheiro</1> de volta',
  cashIsBackColoredRight: 'Dinheiro <1>de volta</1>',
  checkItOffAsYouBuy: 'Risque após comprar',
  connectToPayPalToCashOut: 'Conecte uma conta do PayPal para sacar suas recompensas',
  downloadOurApp: 'Baixe nosso app e use o <1>Karma onde estiver</1>',
  dropSomeShoppingInspo: 'Inspire a sua família a comprar.',
  earnKarmaCashShort: 'Até {{percent, number}}% de Cash Back',
  earned: 'Ganhos',
  enterYourPassword: 'Digite sua senha',
  firstAddToList: 'Primeiro, adicione à lista',
  followOnLinkedin: 'Siga-nos no LinkedIn',
  freshOutCoupons: 'Os cupons acabaram',
  getBuzzedWhenYourWishes: "Seja avisado 🐝 quando seus 'desejos' ficarem mais baratos ou voltarem ao estoque.",
  getIt: 'Pegar',
  getTheApp: 'Baixe o app',
  gotIt: 'Entendi',
  gotStuck: 'Ficou preso? Clique <1>aqui</1> para prosseguir.',
  happyShoppers: '👉 {{count, number}}M+ de consumidores satisfeitos',
  howElseCanWeImproveKarma: 'De que outra forma podemos melhorar o Karma?',
  iNeedThisInMyLife: 'Preciso disso na minha vida',
  info: 'Informações',
  itemUpdatesUnsubscribe: 'Atualizações de itens (quedas de preço, mais estoque e mais)',
  itsAGhostTown: 'Que cidade fantasma!',
  joinTheTeam: 'Junte-se à equipe',
  karmaGetsYouTheLowestPossiblePrice: 'O Karma informa o menor preço possível 👏 todas 👏 as vezes.',
  karmaIsAnApp: 'Karma é um app e extensão que te ajuda a economizar tempo e dinheiro ao fazer compras online.',
  karmaYourFavoriteBrands: 'Dê um <1>Karma</1> nas suas marcas favoritas',
  karmaYourFavoriteBrandsMobile: 'Dê um <1>Karma</1> nas suas marcas favoritas',
  knowHowToShopBetter: 'Saiba como <1>comprar melhor</1> do que o resto do mundo',
  letsPlay: 'Vamos jogar',
  lolWereAVerbNow: '(rs, agora somos uma ação)',
  lookAtYouLittleScroller: 'Olha só você, seu curioso. Parabéns por chegar até aqui.',
  lookAtYouLittleScrollerMobile: 'Olha só você, seu curioso.',
  lookingForInfluencer: 'Procurando parcerias de publicidade?',
  markItemsYouveMadeYourOwnItFulfillsSoGood: 'Marque os itens que você adquiriu. É muito gratificante!',
  markNumberItemsAsFullfilled: 'Você está prestes a marcar {{value}} itens como realizados',
  meetYouAtIn: 'Te encontro na {{retailer}} em 3 segundos...',
  missOut: 'fique de fora',
  missingYouAlready: 'Já estou com saudade!',
  money: 'dinheiro',
  never: 'Nunca',
  nevermind: 'Não',
  noFomoHere: 'Aqui não tem FOMO. Te avisaremos quando seus ‘desejos‘ ficarem mais baratos ou voltarem ao estoque.',
  noNotificationsYet: 'Você está em dia',
  noNotificationsYet2: 'Assim que o preço cair ou o estoque for atualizado, você verá aqui.',
  nowLetsTalPrivacy: 'Agora vamos falar de <1>privacidade<1/>',
  nowLetsTalkAboutPrivacy: 'Agora vamos falar de privacidade 🤫',
  onlineShoppingButBetter: 'Compras online, mas <1>melhor</1>',
  orCopyTheLinkBelowAndSend: 'Ou copie o link abaixo e envie para eles à moda antiga.',
  other: 'Outro',
  passwordValidationNote:
    'Deve ter pelo menos 8 caracteres, incluindo uma letra maiúscula, uma letra minúscula e um número.',
  payLess: 'Pague menos',
  playFavesWithYourItems: 'Use os Favoritos com seus itens',
  preparingYourKarmaCash: 'Preparando seu Cash Back.',
  savingMoneyIsHotLetsGetOnThat: 'Economizar é atraente. Vamos nessa ✌️',
  search: 'Buscar',
  seeHowToSave: 'Veja como salvar',
  skipForNow: 'Pular por enquanto',
  soFarWeSavedYou: 'Até agora, te economizamos',
  sorryForInconvenience: 'Desculpe-nos pelo inconveniente. Prometemos que valerá a pena.',
  starReviews: '👉 {{count, number}}K+ avaliações 4,7 estrelas',
  starTheThingsYouNeedInYourLifeForQuickAccess:
    'Coloque uma estrela nas coisas que você precisa e acesse-as mais rápido.',
  stillWannaUnsubscribe: 'Ainda quer <1>cancelar o recebimento de todos os e-mails do Karma</1>?',
  storePromotionsAndOtherMarketingEmails: 'Promoções de lojas e outros e-mails de marketing',
  storesWorldwide: '👉 {{count, number}} K+ lojas em todo o mundo',
  stuffWorthSavingGoesHere: 'Aqui ficam as coisas que valem a pena salvar 👇',
  sureYouWantToDeleteTheseNumberItems: 'Quer mesmo excluir esses {{value}} itens?',
  sureYouWantToDeleteThisList: 'Quer mesmo excluir essa lista?',
  takeControlOfYourInbox: 'Assuma o controle da sua caixa de entrada',
  theMotherOfAllWishLists: 'A mãe de todas as <1>listas de desejos<1/>',
  thisFieldIsRequired: 'Este campo é obrigatório',
  tryAgain: 'Tente novamente',
  trySearchingForSomethingElse: 'Tente procurar outra coisa.',
  updatePreferences: 'Atualizar preferências',
  wantIt: 'Eu quero',
  weAreBusySelfImproving: 'Estamos ocupados nos aperfeiçoando',
  weAreVerySeriousAboutPrivacy:
    'Levamos sua privacidade muito a sério e nunca venderemos seus dados a terceiros. Nunca.',
  weDontSellYourData: 'Não vendemos os seus dados',
  weGotStuckOnOurWay: 'Ficamos presos a caminho da {{retailer}}!',
  weHitYouUp: 'Entraremos em contato quando encontrarmos um código promocional para essa loja.',
  weHustleForCoupons: 'Vamos atrás de cupons',
  weUseBankLevelSecurity: 'Usamos segurança de nível bancário',
  wellApplyCodesThatSaveYouMoney: 'Aplicamos códigos que lhe poupam $$$.',
  wellTrackAndScanForCoupons:
    'Rastreamos e procuramos cupons para que você não precise fazer isso. <br/>(Tá, a gente não, a nossa IA)',
  wellTrackAndScanForCouponsMobile: 'Rastreamos e procuramos cupons para que você não precise fazer isso.',
  wereAVerbNowLol: '(rs, agora somos uma ação)',
  wereGoingShopping: 'Vamos às compras',
  wereHereToMakeItYours: 'Estamos aqui para <1>#make_it_yours</1>',
  whyUnsubscribeFromAllOurMoneySavingEmails:
    'Por que cancelar o recebimento de todos os nossos e-mails que poupam dinheiro quando você pode desativar só os que não são relevantes?',
  withKarmaYouCanBuy: 'Com o Karma, você pode comprar<br />o que quiser e manter<br />a mulher do banco feliz.',
  withKarmaYourCash: 'Com o Karma, seu dinheiro volta para você como uma espécie de dinheiro mágico ou vudu.',
  yesDisconnect: 'Sim, desconectar',
  yesIDoThat: 'Sim, eu faço isso',
  youHaveToReconnectToWithdraw: 'Você terá que se reconectar para sacar seu Cash Back.',
  youNeedToSaveItemsBeforeYouCanShareYourList: 'Você precisa salvar itens antes de poder compartilhar sua lista.',
  youReATen: 'Você é nota 10 e paga com Karma? Compre online e consiga o menor preço possível 👏 todas 👏 as vezes.',
  youReAboutToMuteNumberItems: 'Você está prestes a silenciar notificações para {{value}} itens',
  yourCashWillComeBackToYou: 'Seu dinheiro voltará para você como uma espécie de dinheiro mágico ou vudu. ',
  yourInformationIsSecured:
    'Suas informações são protegidas usando a criptografia de 256 bits mais moderna para proteção completa.',
  yourSearchCameUpEmpty: 'Sua pesquisa não gerou resultados',
  total: 'Total',
  keepAnEyeOutForTheStatusUpdatesWeWillSendToEmail:
    'Fique de olho nas atualizações de status que enviaremos para {{email}}.',
  psaDidYouKnow: 'PSA: Sabia que você pode',
  addWishItemsFromAnyBrand:
    "Adicionar itens 'desejados' de qualquer marca e aguardar até dizermos que é hora de comprar.",
  capturePurchaseReadyShoppers: 'Atrair consumidores prontos para comprar, mostrando seus cupons mais interessantes.',
  gainFullFunnelInsights: 'Obter insights de full-funnel sobre a intenção do consumidor com cada item salvo.',
  boostCartEngagement: 'Aumentar o envolvimento com o carrinho com as nossas atualizações de itens em tempo real.',
  promoteLongTermGrowth:
    'Promover o crescimento no longo prazo através de campanhas personalizadas dentro do ecossistema Karma.',
  reachNewAudiences: 'Alcançar novos públicos através de diversas campanhas adaptadas à sua marca',
  influencerCollaborations: 'Colaborações com influenciadores',
  teamUpWithTopInfluences: 'Junte-se aos principais influenciadores que mais combinam com a identidade da sua marca.',
  socialPosts: 'Publicações sociais',
  giveANewFollowing: 'Consiga novos seguidores com campanhas personalizadas e ricas em conteúdo.',
  brandFocusedNewsletters: 'Newsletters focadas na marca',
  letYourOffersShine: 'Deixe suas ofertas brilharem em e-mails selecionados e muito aguardados',
  driveTrafficWhenYouNeedIt:
    'Conduza o tráfego para onde você precisa que ele vá com nossas inserções em página inicial para compras',
  dashboardBanners: 'Banners do painel',
  flauntYourLatestOfferings: 'Mostre suas ofertas mais recentes com recursos visuais atraentes.',
  dailyFeatured: 'Destaque do dia',
  highlightDeals: 'Destaque as ofertas onde é mais importante.',
  dedicatedPopUps: 'Pop-ups dedicadas',
  activelyServeYourPromos: 'Mostre ativamente suas promoções para ninguém as perder.',
  createAnotherTouchpointForYourBrand: 'Crie outro ponto de contato para sua marca',
  increaseEngagement:
    'Aumente as taxas de engajamento e conversão por meio de notificações push segmentadas em dispositivos móveis e na web.',
  karmaIsOnlineShoppingButBetter: 'Karma são compras online, mas melhor.',
  transactionsNumber: '👉 {{count, number}}M+ de transações',
  partnershipsReview4: 'Isso é fantástico para criar sua lista de desejos e economizar!',
  partnershipsReviewAuthor4: 'Emily Smith',
  partnershipsReview5:
    'É literalmente a melhor extensão que já baixei. É o melhor para economizar e ganhar dinheiro ao mesmo tempo!',
  partnershipsReviewAuthor5: 'Selena Roblox',
  noNeedToSlideIntoOurDMs:
    'Não precisa nos mandar direct (mas pode, se quiser 😏). Nossa equipe está aqui para o que você precisar.',
  supportIssues: 'Problemas com suporte',
  adsAndPartnerships: 'Anúncios e Parcerias',
  jobOpportunities: 'Vagas de emprego',
  publicRelations: 'Relações públicas',
  letsChat: 'Vamos conversar',
  earnings: 'Ganhos',
  allTime: 'Totais',
  ordersMayTakeHoursToAppear: 'Os pedidos podem demorar até {{value, number}} horas para aparecer.',
  youHaventReceivedAnyPayoutsYet: 'Você ainda não recebeu nenhum pagamento ',
  alerts: 'Alertas',
  featuresReview1:
    'Adicionei um par de tênis à minha lista de desejos e literalmente no dia seguinte recebi um aviso de que estava com 50% de desconto. Como é que eu comprava as coisas sem vocês?',
  featuresReviewAuthor1: 'Sandra C. Martinez, avaliadora da App Store',
  featuresReview2:
    'Este é sem dúvidas o melhor app de compras inteligente, e eu conheço vários outros. Na verdade, sinto que estou enganando o sistema um pouco porque estou economizando de verdade! Eu sempre costumava pagar o valor cheio e me sentir como uma otária',
  featuresReviewAuthor2: 'Gertie D. Ackerman, avaliadora da App Store',
  featuresReview3:
    'Estava comprando um notebook novo que já estava com 25% de desconto. Quando apertei ‘pagar com Karma’, notei que o total era ainda menor. Isso acontece sempre que pago com o aplicativo',
  featuresReviewAuthor3: 'Irene J. Cox, avaliadora da App Store',
  downloadNow: 'Baixe agora',
  wannaBeDeskBuddies: 'Quer ser colega de mesa?',
  seeOpenPositions: 'Ver vagas',
  weLiveAndSwearBy: 'Vivemos e juramos por...',
  goodKarma: 'Bom Karma',
  weBelieveThatGoodVibes: 'Acreditamos que ~boas vibrações~ são um estilo de vida e nos apegamos a isso.',
  beingTrue: 'Ser verdadeiro',
  theresNoUSvsU:
    'Não existe isso de NÓS contra VOCÊ. Nossas mesas são sempre redondas e reservamos um lugar para você.',
  passion: 'Paixão',
  weHaveThatFireYouKnow:
    'A gente tem aquele fogo, sabe? Funcionamos à base de motivação, persistência e amor pelo que fazemos.',
  entrepreneurship: 'Empreendedorismo',
  weWantItWeGetIt:
    'Quando queremos, conseguimos. Não temos tempo a perder com Zooms sem fim. Vamos atrás do que queremos.',
  mutuality: 'Mutualidade',
  wereMadeUpOfAwesomePeople:
    'Somos todos pessoas incríveis que entendem que trabalho em equipe não é suficiente. Realmente nos importamos uns com os outros.',
  buildCustomerLoyalty: 'Fidelize clientes com cashback instantâneo',
  itemSaving: 'Salvamento de itens',
  itemUpdates: 'Atualizações do item',
  backInStockAlerts: 'Voltou ao estoque',
  lowInStockAlerts: 'Estoque baixo',
  storePromotions: 'Promoções da loja',
  exclusive: 'exclusivo',
  couponCopied: 'Cupom copiado',
  completedDesc:
    'A loja confirmou seu pedido. Todo Cash Back obtido pode ser retirado {{days, number}} dias após a data da compra e somente depois de atingir o mínimo de {{currency}}{{amount, number}}.',
  pendingDesc:
    'A loja recebeu seu pedido. Poderá aparecer como pendente por até {{days, number}} dias, dependendo da política de devolução da loja.',
  cancelledDesc: 'A loja nos informou que seu pedido foi cancelado ou reembolsado integralmente.',
  downloadNowItsFree: 'Baixe agora, é grátis',
  weLiveToMakeOurShoppersHappy: 'Vivemos para fazer nossos consumidores felizes',
  moneySavedForYou: 'Dinheiro economizado para você',
  happyShoppers2: 'Consumidores felizes',
  starReviews2: 'Avaliações {{value, number}} estrelas',
  storesWorldwide2: 'Lojas em todo o mundo',
  whyYouWill: 'Por que você vai',
  it: 'ele',
  multiBrandWishLists:
    'Listas de desejos com várias marcas? Arrepios pra valer. Identifique algo que você adora de qualquer marca, adicione à sua lista do Karma e aguarde até avisarmos que é hora de comprar.',
  addKarmaToYourMobile: 'Baixe<br />nosso app<br />e use o<br />Karma onde estiver',
  appStoreReview1:
    'Adicionei uma paleta de sombras à minha lista e no dia seguinte recebi uma notificação de que estava com 50% de desconto. Obrigada!!',
  appStoreReview2: 'O fato de o preço mais baixo estar bem ao meu alcance é um perigo. Mas também amo isso',
  appStoreReview3:
    'Acabei de conseguir o menor preço em fones de ouvido novos enquanto esperava o ônibus. É fácil demais',
  appStoreReviewBy: 'Avaliação em loja de apps por: {{name}}',
  yourInfoSafeWithUs: 'Suas informações estão seguras com a gente',
  whyGiveOutYourCCDeets: 'Por que dar seus dados de cartão de crédito quando pode mantê-los em um só lugar?',
  partyForOne: 'Reserva pra 1',
  wellNeverSellYourDataToAnyThirdParties:
    'Nunca venderemos seus dados a terceiros, ponto final. Com segurança de nível bancário, seus dados estão protegidos contra olhares indiscretos.',
  buyWithoutATrace: 'Compre sem deixar rastros',
  weWontLetAnyoneTrackYourShoppingHabits:
    'Não deixaremos ninguém rastrear seus hábitos de compras. Aqui ninguém te julga.',
  spotSomethingYouLoveFromAnyBrand:
    'Identifique algo que você adora de qualquer marca, adicione à sua lista do Karma e aguarde até avisarmos que é hora de comprar.',
  needIt: 'Preciso disso',
  appStoreReviewer: 'Avaliador da App Store',
  appStoreReview4:
    'Confio muito neste app para manter o controle de todos os meus itens desejados em um só lugar para conseguir o melhor preço possível.',
  appStoreReview5: 'Este app me ajudou a economizar muito dinheiro.',
  wishlist: 'Lista de desejos',
  getTheLowestPriceAtAllYourFavoriteBrands: 'Consiga os preços mais baixos em todas as suas marcas favoritas.',
  getTheAppForFree: 'Baixe o aplicativo grátis',
  addKarmaSpaced: 'Adicione Karma<br />ao desktop<br />para poder comprar<br />durante o horário de trabalho.',
  spotSomethingYouLoveFromAnywhere:
    'Identifique algo que você adora de qualquer lugar, adicione à sua lista do Karma e aguarde até avisarmos que é hora de comprar.',
  getCouponsCashbackWithPeriod: 'Receba cupons, cashback e alertas de descontos.<br />Pague sempre o preço mais baixo.',
  getCouponsCashbackWithAnd: 'Receba cupons, cashback, alertas de descontos<br />e pague sempre o preço mais baixo.',
  clickTheLoginLinkFromYourPhone: 'Clique no link de login do seu telefone para acessar o app Karma.',
  getItOn: 'Obtenha na',
  downloadOnThe: 'Baixe na',
  likeShoppingFromYourComputer: 'Curte fazer compras no seu computador?',
  getTheKarmaExtensionToShopEvenBetter: 'Baixe a extensão do Karma e compre ainda melhor.',
  headerMobileLogin: 'Karma | Instalar',
  noFomoHereMobile:
    'Aqui ninguém passa vontade. Te avisaremos quando seus ‘desejados‘ ficarem mais baratos ou voltarem ao estoque.',
  withKarmaYourCashMobile: 'Com o Karma, seu dinheiro volta para você como uma espécie de dinheiro mágico ou vudu.',
  spotSomethigYouLoveMobile:
    'Identifique algo que você adora de qualquer lugar, adicione à sua lista do Karma e aguarde até avisarmos que é hora de comprar.',
  wellTrackAndScanForCouponsMobile2:
    'Rastreamos e procuramos cupons para que você não precise fazer isso. (Tá, a gente não, a nossa IA)',
  weHustle: 'A gente sai atrás',
  forCoupons: 'de <1>cupons</1>',
  theMotherOfAll: 'A mãe de todas as',
  wishlists2: 'listas de desejos',

  // NEW PHRASES
  moneySavedForUsers: 'Money saved for users',
  whyYouLoveMerchantsTitleDesktop3: '<1>One-swipe<1/> checkout is yours',
  whatItsLikeWorkingAtKarma2: 'What’s it like working at Karma?',
  makeItYours: 'Make it yours',
  continueWith: 'Continue with {{provider}}',
  onItsWay: 'On its way...',
  weVeEmailedInstructionsForResettingYourPassword:
    'We’ve emailed instructions for resetting your password to {{email}}',
  wrongEmailTryAgain: 'Wrong email? Try again',
  goToEmail: 'Go to email',
  heyYouLetsJumpBackIntoSaving: 'Hey you! Let’s jump back into saving',
  firstConfirmItsYou: 'First, confirm it’s you',
  letsDoThis: 'Let’s do this',
  signUpAndGet: 'Sign up and get',
  moneyOnUs: '{{currency}}{{value, number}} on us',
  usersHeroTitle: 'Your\nbank account’s gonna love this.',
  tellMeMore: 'Tell me more',
  createNewPassword: 'Create new password',
  joinKarma: 'Join Karma',
  whyYouLoveMerchantsSubtitle3: 'Pay with Karma works with all retail platforms, with zero\nintegration and no fees.',
  saveItemsFromStores: 'Save items from your favorite stores with a single click',
  easilySaveAndKeep:
    'Easily save and keep track of everything you want to buy. The best\npart? You’ll get notified the second any of your saved items\ngo on sale, or come back in stock.',
  addTheFreeKarma:
    "Add the free Karma button to your browser so you can\neasily keep track of everything you want to buy. The best\npart? You'll get notified the second any of your saved items\ngo on sale, drop in price, or come back in stock.",
  getButtonAndGetEverything: 'Get the free Karma button and\nget everything you want on sale',
  getKarmaItIsFree: "Get Karma - It's Free!",
  onYourPhone: 'On your phone? Save items on the go with our free app',
  hereHowTheButtonWorks: "Here's how the Karma\nbutton works",
  dontSellMyPersonalInformation: 'Don’t sell my personal information',
  postCode: 'Postcode',
  ifThisWontHelp: "If this won't help, ",
  contactOurSupportCenter: 'contact our support center.',
  wellKeepAnEyeOnIt: 'We’ll keep an eye on it & will let u know ASAP if the price drops',
  seeYourSavedItems: 'See your saved items',
  logInAndSaveItemToKarma: 'Login & Save item to Karma',
  blogPromotions: 'Blog promotions',
  goToStore: 'Go to store',
  visitStorePage: 'Visit store page',
  favStoresUpdated: 'Your favorite stores were successfully updated.',
  availableCoupons_plural: '{{count}} available coupons',
  availableCoupons: '{{count}} available coupon',
  findAndComparedTheBestDeals: 'Finds and compares the best deals',
  karmaHelpsYouShopSmarter: 'Karma helps you shop smarter by finding the best benefits and rewards at checkout',
  expiring: 'Expiring',
  today: 'Today',
  tomorrow: 'Tomorrow',
  days: '{{count, number}} DAY',
  weeks: '{{count, number}} WEEK',
  months: '{{count, number}} MONTH',
  daysPlural: '{{count, number}} DAYS',
  weeksPlural: '{{count, number}} WEEKS',
  monthsPlural: '{{count, number}} MONTHS',
  tellUsWhyYouUninstalledTheExtension: 'Tell us why you uninstalled the extension',
  tooManyPopUpsWhileIShop: 'Too many pop-ups while I shop',
  couponsDontWork: 'Coupons don’t work',
  dataPrivacyConcerns: 'Privacy concerns',
  dataPrivacyConcernsTitle: 'Your privacy matters',
  dataPrivacyConcernsDescripReason:
    'Online privacy is serious business.<2/>We’re <1>GDPR & CCPA compliant</1>, and you can read </2>our <1>Privacy Policy</1> if you want all the details!',
  noRelevantDealsInMyFavedStores: 'No relevant deals in my faved stores',
  noRelevantDealsInMyFavedStoresDescription:
    'Karma <1>tracks price drops</1><2/> and <1>restocks</1>, so when a deal pops up, <1>you’ll<2/> know first.</1><2/> Stick around, and we’ll keep an eye out for<2/> savings!',
  theKbuttonWasInMyWay: 'The ‘K button’ was in my way',
  theKbuttonWasInMyWayDescription: 'No need to kick us out completely.<2/> Want to try adjusting it? Check out how',
  tooManyPopUps: 'Too many pop ups',
  tooManyPopUpsTitle: 'Timing is everything.',
  tooManyPopUpsDescription:
    'You can actually tweak how often Karma helps in<2/> settings, so it only <1>appears when you want it to.</1><2/> Give that a try?',
  causedProblemsWithMyBrowser: 'Caused problems with my browser',
  tellUsMoreOptional: 'Tell us more (optional):',
  shareYourThoughtsWithUs: 'Share your thoughts with us',
  myFavoriteStoresAreNotSupported: 'My favorite stores are not supported',
  notReadyToLetGoYet: 'Not ready to let go yet? Reinstall Karma with just one click',
  chatWithUsAndGet: 'Chat with us & get<br />${{count}} Amazon Gift Card',
  scheduleAMeetingAndEarnGiftCard:
    'Schedule a {{minutes}}-minute interview and earn a<br />${{count}} Amazon gift card.',
  scheduleAnInterview: 'Schedule an interview',
  compareProductsBeforeYouBuy: 'Compare products before you buy',
  downloadWithKarmaAndSaveMajorCash: 'Download Karma<br/>and save major $$$',
  youSearchedFor: 'You searched for',
  yourSavedItems: 'Your saved items',
  moreForYou: 'More for you',
  headerGlobalSearch: 'Karma | {{query}}',
  noResultsFoundFor: 'No results found for',
  pleaseReviewYourSpellingOrTryDifferentKeyword: 'Please review your spelling or try different keyword',
  heyThere: 'Hey, {{name}}',
  myAccount: 'My account',
  accountSettings: 'Account settings',
  trendingNow: 'Trending now',
  helpUsImproveKarma: 'Help us improve Karma',
  yourFavoriteStores: 'Your favorite stores',
  chooseYourFavoriteStores: 'Choose your favorite stores',
  viewStoreInfo: 'View store info',
  addStore: 'Add store',
  findMoreStores: 'Find more stores',
  whatAreYouShoppingFor: 'What are you shopping for?',
  searchForAnyItemBrandOrStore: 'Search for any item, brand or store',
  savedFromStore: 'Saved from store',
  manageFavoriteStores: 'Manage favorite stores',
  hasNoActiveCoupons: '{{retailer}} has no active coupons',
  checkOutOtherStores: 'Check out other stores for more deals',
  youCanStillEarn: 'You can still earn {{number}}% cashback with Karma!',
  retailerCoupons: '{{retailer}} coupons',
  nothingSavedYet: 'Nothing saved yet?',
  useOurBrowserExtension:
    'Use our browser extension on your {{retailerName}} visit to quickly add items to your favorites. Your shopping journey starts here!',
  letsMakeItPersonal: 'Let’s make it personal',
  selectAndTrack: 'Select your favorite stores and track coupons and deals',
  chooseYourFaves: 'Choose your faves',
  code: 'Code',
  itemFound: '{{count, number}} item found',
  itemFound_plural: '{{count, number}} items found',
  storeFound: '{{count, number}} store found',
  storeFound_plural: '{{count, number}} stores found',
  itemsTitle: 'Items',
  storeInfo: 'Store info',
  preOwned: 'Pre-owned',
  refurbished: 'Refurbished',
  favorited: 'Favorited',
  allPromotionsOrOffers:
    "All promotions or offers by any of our partners are subject to the applicable partner's terms and conditions, which may be changed by the partner at its discretion. We may receive a commission for purchases made through our links or using our coupons. Eligibility for a welcome bonus is subject to section 5 of Karma’s Terms & Conditions.",
  shippingInfo: 'Shipping info.',
  freeShipping: 'Free shipping',
  overMinAmount: 'over {{currency}}{{value, number(minimumFractionDigits: 2)}}',
  delivers: 'Delivers',
  deliveryDays: '{{value, number}} days',
  freeReturns: 'Free returns',
  upToDays: 'up to {{value, number}} days',
  deliveryInfo: 'Delivery info.',
  returnsInfo: 'Returns info.',
  notAvailable: 'Not available',
  minOrderMayApply: 'Min. order may apply',
  hottestDeals: 'Hottest deals',
  discoverCouponsAndExclusiveOffers: 'Discover coupons and exclusive offers',
  moreFromStore: 'More from {{store}}',
  seeWhatsTrendingNow: 'See what’s trending now',
  automaticallyApplyCoupons:
    'Automatically apply coupons at checkout, save what you love and earn cashback — all with the Karma extension.',
  deleteMyAccount: 'Delete my account',
  areYouSureDeleteAccount: 'Are you sure you want to delete your account?',
  deletingYourAccountWill:
    'Deleting your account will permanently remove all of your information, your saved items and your earnings from our database, and this action cannot be undone.',
  cancel: 'Cancel',
  accountDeletedSuccessfully: 'Account deleted successfully',
  shopOnTheGo: 'Shop on-the-go with Karma app',
  moveFromDevice: 'With Karma, effortlessly move from one device to another as you shop.',
  fewMomentsWeAreStillWorkingOnSavingItemsToThisList:
    'Few moments, we’re still working on saving items to this list... ',
  notificationDate: '{{date, shortFromNowDate}} ago',
  enableKarmaOn: 'Enable Karma on Safari',
  karmaNeedsToBeActivated: 'Oops! Karma needs to be activated',
  toAccessOurCouponScanner: 'to access our coupon scanner',
  dontSeeReview: 'I don’t see a “Review” button',
  iosOnboardingFlowYouNeedToUseSafari: 'You need to be in Safari to use<1></1>the Karma extension',
  iosOnboardingFlowCopyTheLink: 'Copy the link below and paste it in<1></1>Safari to continue.',
  iosOnboardingCopyLink: 'Copy link',
  iosOnboardingLinkCopied: 'Link copied',
  tapExtensionThenSelect: 'extension, then <1>select both middle options</1>',
  tap: 'Tap',
  activate: 'Activate',
  grantAccess: 'Grant access',
  continueShopping: 'Continue shopping',
  sweOnboardingStep1_1_2: 'in your search bar',
  sweOnboardingStep1_2: 'Select <1>“Manage Extensions”<1/>',
  sweOnboardingStep1_3: 'Toggle on <1>“Karma”</1>',
  sweOnboardingStep2_1_old: 'Tap the <1>A</1><2>A</2> in the address bar again',
  sweOnboardingStep2_2_old:
    'Tap the Karma extension <1></1>, and select <3>“Always Allow...”</3>, then <5>“Always Allow on Every Website”</5>',
  sweOnboardingStep2_3_old: 'Select “Always allow”',
  sweOnboardingStep2_4_old_1: 'Select “Always allow”',
  sweOnboardingStep2_4_old_2: '“On every Site”',

  sweOnboardingStep2_5_old_1: 'Go back to the',
  sweOnboardingStep2_5_old_2: 'Karma app',
  sweOnboardingStep2_1: 'Tap <1>“Review”</1> in the top right corner, then <3>select both middle options</3>',
  shopSmarter: 'Shop better with\nthe power of AI',
  joinOurUsers: 'Join our {{number, number}} million users\nwho are shopping\nbetter from all their\ndevices',
  browseAndBuy:
    'Browse and buy from our desktop extension or\nuse the Karma app to ensure you’re always\ngetting the most out of your purchase.',
  joinCard1: '<0>$5 cash</0><1>at sign-up</1>',
  joinCard2: '<0>15K</0><1>5 star reviews</1>',
  joinCard3: '<0>13M+</0><1>coupons applied</1>',
  joinCard4: '<0>80 million</0><1>items saved</1>',
  joinCard5: '<0>$482</0><1>yearly avg savings</1>',
  joinCard6: '<0>$126</0><1>avg Cash Back earnings</1>',
  joinCard7: '<0>{{value}}M+</0><1>shoppers</1>',
  joinCard8: '<0>$7.50</0><1>avg order savings</1>',
  whatMakesKarmaGood: 'What makes Karma\nso good?',
  karmaGoodTitle1: 'Karma let’s you shop\nbetter from anywhere',
  karmaGoodDescription1:
    'Karma’s browser extension meets you\nwherever you shop. Shop directly in the Karma\napp or share the items you want to Karma.',
  karmaGoodTitle2: 'Helps you plan your\nnext purchases',
  karmaGoodDescription2:
    'Not ready to buy just yet? Save it for later in the\nKarma app or share it to Karma and shop more\nmindfully. You can keep an eye on all your\nsaved items in one place.',
  karmaGoodTitle4: 'So you can buy at the\nright time',
  karmaGoodDescription4:
    "Karma uses clever technology to track if the\nprice drops, or when it's back in stock, so you\ncan buy at the right time.",
  karmaGoodTitle5: 'Automatically finds you\n coupons at checkout',
  karmaGoodDescription5:
    'Karma automatically finds and applies the best\n coupons for you while you shop on Safari, so\n you know you get the best price every time.',
  onlyOnMobile: 'Only on the mobile app',
  empowerTouToMake: 'Empower you to\nmake the right\nchoices at the right\ntime when you shop\nonline.',
  dontTakeOurWord: 'Don’t take our word for it',
  totalSavings: 'Total savings',
  joinOurUsersDesktop: 'Join our {{number, number}} million users who are\nshopping better from all their devices',
  andAutomaticallyFindsYouCouponsAtCheckout: 'And automatically finds you coupons at checkout',
  clickAlwaysAllowOnEveryWebsite: 'Click <2>“Always Allow on Every Website“</2> so we can work on all your fave sites',
  weNeedYourPermissionToAutomaticallyShowYouTheBestDeals:
    'We need your permission to automatically show you the best deals on all your favorite shopping websites.',
  yourPrivacyAndSecurityIsImportantToUs: 'Your privacy and security are important to us - it’s in our',
  whileKarmaWillStillWork: 'While Karma will still work, it’ll require more effort on your part to find deals.',
  unfortunatelyWithoutTheAlwaysAllowPermission:
    'Unfortunately, without the “Always Allow on Every Website” permission you’ll have to manually click Karma whenever you shop',
  noThanksSignUpForAnAccount: 'No thanks, Sign up for an account',
  logInWithEmail: 'Log in with email',
  signUpWithEmail: 'Sign up with email',
  iAgreeToTermsOfUseAndPrivacyPolicy: 'I agree to <1>Terms of Use</1> and <3>Privacy Policy</3>',
  joinOurEnergeticTeam: 'Join Our Energetic Team',
  atKarmaWeReNotJustAboutWork:
    'At Karma, we’re not just about work; we’re about creating an environment where everyone’s input is valued and where each day brings a new opportunity for growth and impact.',
  beAPartOfTheJourney: 'Be a part of the journey',
  noPositionsAvailable: 'No positions available',
  apply: 'Apply',
  dontSeeAnythingThatFitsYourSkillSet:
    "Don't see anything that fits your skill set? Don't let that stop you from reaching out! If you think you can help us grow, send an email to",
  ifYouReReadyToMakeAnImpact:
    'If you’re ready to make an impact and thrive in a setting that values speed, fun, and collaboration, Karma might be your next great adventure.',
  exploreOurCareerOpportunities:
    'Explore our career opportunities and find out how you can contribute to our exciting journey ahead. Join us, and let’s achieve greatness together!',
  welcomeToKarma:
    'Welcome to Karma—where technology meets savvy shopping. Join us in our mission to revolutionize the way you shop, ensuring every purchase is just right for you.',
  empoweringSmartShopping: 'Empowering Smart Shopping:\nThe Karma Story',
  ourMissionPart1:
    'At Karma, we believe in empowering shoppers to make wise and informed purchasing decisions. Founded in 2015, our mission has always been to guide consumers toward smarter, more responsible shopping. As both a browser extension and mobile app, Karma harnesses the power of advanced AI to enhance your shopping experience. This technology predicts the optimal time to make a purchase, ensuring you get the best deal possible.',
  ourMissionPart2:
    'Over the years, Karma has continuously evolved, integrating cutting-edge technology to keep pace with the dynamic e-commerce landscape. We take pride in helping our users avoid buyer’s remorse and overspending by providing them with the tools they need to shop confidently!',
  hearFromOurUsers: 'Hear from our users',
  karmaPatents: 'Karma patents',
  systemAndMethodForPreauthorizing: 'System and method for preauthorizing database transaction commits',
  systemAndMethodForScraping: 'System and method for near real time web scraping',
  startYourShoppingJourney: 'Start your shopping journey',
  searchForItemBrandStore: 'Search for an item, brand or store',
  quillDisclosure: 'HP, Epson, & Samsung excluded',
  theKButtonIsInMyWay: 'The K button is in my way',
  iOnlyInstalledItForAOneTimeDeal: 'I only installed it for a one-time deal',
  iOnlyInstalledItForAOneTimeDealTitle: 'We love a savvy shopper!',
  iOnlyInstalledItForAOneTimeDealDescription:
    'But did you know Karma helps you <1>save every<2/> time you shop?</1> No extra effort needed.<2/> Why not keep it around?',
  itWasntHelpful: 'It wasn’t helpful',
  itWasntHelpfulTitle: 'Karma’s got your back!',
  itWasntHelpfulDescription:
    'We track <1>price drops, restocks, and give<2/> you Cash Back.</1><2/> In the US? We’ll show you the <1>best credit card rewards at checkout.</1><2/> Give it another shot?',
  iUseOtherShoppingExtensions: 'I use other shopping extensions',
  iUseOtherShoppingExtensionsDescription:
    'But don’t forget, Karma finds <1>hidden price drops</1><2/> and <1>exclusive rewards</1> that others might miss.<2/> Why not double up?',
  tooManyCouponPopupsAtCheckout: 'Too many coupon pop-ups at checkout',
  cookies:
    'Karma uses cookies to ensure you see the things we think you’ll love the most. <2>Click here</2> to read our full policy',
  decline: 'Decline',
  confirmYourCookieSettings: 'Confirm your cookie settings',
  youControlHowWeUseCookies:
    'You get to control how we use cookies on each device and browser you use. These settings will apply to your current device when you use {{browser}}.',
  whatAreCookies: 'What are cookies?',
  cookiesAndTrackingTechnologies:
    'Cookies and tracking technologies are small text files stored on your device when you use a web browser. Some cookies are essential for you to use our site, while other cookies collect data about your browsing habits. We use this data to give you the best experience.',
  marketing: 'Marketing',
  weUseMarketingCookies: "We use marketing cookies to deliver ads we think you'll like.",
  marketingCookiesLet: 'For example, marketing cookies let us show you personalized ads based on your interests.',
  performance: 'Performance',
  weUsePerformanceCookies: 'We use performance cookies to understand how you interact with our site.',
  performanceCookiesHelp:
    'For example, performance cookies help us learn which parts are the most popular and which parts we could improve for you.',
  functional: 'Functional',
  weUseFunctionalCookies: 'We use functional cookies to customize your experience.',
  functionalCookiesLet:
    'For example, functional cookies let us remember your preferences like language, country or region, and text sizes.',
  essential: 'Essential',
  weUseEssentialCookies: 'We use essential cookies to make our site work for you.',
  essentialCookiesLet:
    'For example, essential cookies let you securely sign in and browse our site. These cookies help us keep your account safe and prevent fraud.',
  youCanReadMoreAboutCookies: 'You can read more about how we use cookies in our <2>Cookie Statement</2>.',
  confirmCookieSettings: 'Confirm Cookie Settings',
  noMinimumOrderValue: 'No minimum order value',
  fromToDays: '{{value, number}} to {{value2, number}} days',
  headerLogin: 'Karma | Login',
  headerOnboarding: 'Karma | Onboarding',
  yourDataHasBeenRemoved: 'Your data has been successfully removed.',
  confirmationCode: 'Confirmation code: {{code}}',
  startOnlineShopping: 'Start online shopping to see Karma in action',
  trendingOffers: 'Trending Offers',
  useCode: 'Use code: {{code}}',
  getDeal: 'Get Deal',
  buyNow: 'Buy now',
  trendingCoupons: 'Trending Coupons',
  searchResultsFor: 'Search Results for "{{search}}"',
  trendingItems: 'Trending Items',
  curateSmartWishlists: 'Curate Smart wishlists',
  karmaWillLetYouKnow: 'Karma will let you know when the items you want go on sale or are back in stock',
  saveEarnAtCheckout: 'Save & Earn at checkout',
  weApplyBestCoupon:
    'We’ll automatically apply the best coupon codes on the web at checkout & reward for your purchase on 1000’s of stores',
  scanToGetApp: 'Scan to get the app',
  unlockYourCreditCardsBenefits: 'Unlock your credit cards benefits',
  easilyCompareBetweenCreditCards:
    'Easily compare between the credit cards rewards to choose the best one to use at checkout',
  emailPositiveFeedbackThankYou: 'Thank you for your feedback!',
  emailPositiveFeedbackYourExperience: 'Share your experience by leaving a review on your platform of choice:',
  headerPositiveFeedback: 'Karma | Email Positive Feedback',
  headerNegativeFeedback: 'Karma | Email Negative Feedback',
  emailNegativeFeedbackTitle: 'We’re listening, share your feedback',
  emailNegativeFeedbackSubTitle:
    'To help us resolve the issue faster, please let us know what’s wrong with the notification',
  emailPriceDoesNotMatch: 'The email price does not match the website price',
  emailItemNotOnSale: 'The item is not on sale',
  emailItemOutOfStock: 'The item is out of stock',
  emailLinkNotWorking: 'The link is not working',
  emailPromoCodeNotAccepted: 'Promo code is not accepted by store',
  emailPromoCodeOnPage: 'Couldn’t apply the promo codes on the page',
  emailOther: 'Other',
  headerNegativeFeedbackSuccess: 'Karma | Negative Feedback Success',
  emailNegativeFeedbackSuccessTitle: 'Thank you for submitting your feedback!',
  emailNegativeFeedbackSuccessSubTitle: 'Our support team is on it, and we’ll be sure to update you soon.',
  enterValue: 'Enter value...',
  httpErrorOccurred: 'An error occurred, please try again later',
  everWonderWhichCreditCard: 'Ever wonder which credit card to use to get the best rewards?',
  doNotWorryYouCovered: 'Don’t worry, we’ve got you covered!',
  linkYourCardType: 'Link your card type – No card numbers, no personal info needed.',
  shopLikeAlways: 'Shop like always – See your rewards instantly at checkout.',
  compareAndDecide: 'Compare and decide – Easily choose the best card to maximize your rewards.',
  exclusivelyForUS: '*Exclusively for US users – try it today!',
  clientUninstallRespTitle: 'Thank You for Trying Karma!',
  clientUninstallRespTitle1: 'We appreciate you giving Karma a shot.',
  clientUninstallRespTitle2: 'While you’re off hunting for deals on your own, remember—we’re always here',
  clientUninstallRespTrackPriceDrop: 'Track price drops so you never overpay',
  clientUninstallRespHiddenDisc: 'Find hidden discounts and Cash Back',
  clientUninstallRespAlert: 'Alert you when items restock',
  clientUninstallRespShowBest: 'Show the best credit card perks at checkout',
  clientUninstallRespUSOnly: '*US only',
  clientUninstallRespWhantKeep: 'Want to keep saving?',
  otherTitle: 'We’d love to know\n why you’re leaving!',
  noRelevantDealsInMyFavedStoresTitle: 'We get it, some stores don’t always\n have discounts.',
  theKbuttonWasInMyWayTitle: 'You can move or minimize\n it in settings',
  iUseOtherShoppingExtensionsTitle: 'We respect the hustle\n saving money is the goal!',
  couponsAndPromosHub: 'Coupons and Promos Hub',
  weLoveToKnowYou: 'We’d love to get to know you better',
  takesLessThanMinute: 'Takes less than a minute, and helps us improve. Your answers stay private—promise.',
  skip: 'Skip',
  nonBinary: 'Non-binary',
  embeddedLoyaltyLearnMoreBtn: 'Learn more',
  embeddedLoyaltyStartTodayBtn: 'Start Today',
  embeddedLoyaltyGetStartedTitle: 'Get Started Today',
  embeddedLoyaltyGetStartedDescription:
    'Don’t miss the chance to transform your customer experience. Join the brands leveraging Karma’s White-Label Embedded Loyalty Platform to build lasting relationships and drive growth.',
  embeddedLoyaltyGetStartedBtn: 'Contact Us',
  embeddedLoyaltyHeader: "Elevate Your Banking Ecosystem with Karma's Loyalty Solution",
  embeddedLoyaltyHeaderDescription:
    'Karma’s <1>white-label embedded loyalty platform</1> positions your bank as the leader in delivering personalized cashback, rewards, and coupon opportunities for your customers whenever they shop – meeting their growing demand for <1>convenience, value, and engagement</1>, while ensuring that your brand is always <1>front and center</1>.',

  embeddedLoyaltyRewards: 'Empowering Banks to Deliver Seamless Rewards With Every Purchase',
  embeddedLoyaltyRewardsDescription:
    'Transform customer interactions into meaningful experiences while enhancing brand loyalty and driving valuable engagements.',
  embeddedLoyaltyChooseKarmaTitle: 'Why Choose Karma’s\n White-Label Loyalty Platform?',
  embeddedLoyaltyChooseKarmaDescription:
    'Our platform is built to meet the highest industry standards, fitting naturally into your ecosystem while keeping your brand in the forefront.',
  embeddedLoyaltyFeaturesTitle: 'Key Features & Benefits',
  embeddedLoyaltyAllFeaturesBtn: 'View all of our features',
  viewAllFeatures: 'View All Features',

  embeddedLoyaltyWhatSetsTitle: 'What Sets Us Apart?',
  embeddedLoyaltyWhatSetsDescription:
    'Unlike other solutions, Karma’s platform is designed to seamlessly blend into your brand experience. By focusing on ease of use and advanced technology, we help you foster deeper connections with your customers, ensuring loyalty programs become a natural extension of your business.',

  embeddedLoyaltyPlatformCaption: 'Effortless Integration for Banks',
  embeddedLoyaltyPlatformDescription:
    'Karma’s platform fits naturally into your ecosystem, offering a turnkey solution that minimizes technical complexity.',
  embeddedLoyaltyPlatformCaption2: 'Boost Brand Loyalty with White-Label Solutions',
  embeddedLoyaltyPlatformDescription2:
    'Keep your brand front and center. Karma ensures that every interaction reflects your identity, strengthening customer trust and loyalty.',
  embeddedLoyaltyPlatformCaption3: 'Bank-Grade Security and Compliance',
  embeddedLoyaltyPlatformDescription3:
    'Built to meet the highest industry standards, Karma’s platform ensures complete compliance with PCI and SOC certifications.',

  embeddedLoyaltyFeaturesTitle1: 'Streamlined Payment Autofill',
  embeddedLoyaltyFeaturesDescription1:
    'Simplify transactions with auto-filled payment details, keeping your card “top-of-wallet”. This feature minimizes checkout friction, ensuring your card is the preferred choice every time.',
  embeddedLoyaltyFeaturesTitle2: 'Upsell & Cross Sell Financial Products',
  embeddedLoyaltyFeaturesDescription2:
    'Easily offer your customers new financial products such as virtual cards, installments, new (issuance) credit card offers, savings accounts, or other bank products directly from the branded browser widget - live exactly when needed.',
  embeddedLoyaltyFeaturesTitle3: 'Earn & Redeem Points at Checkout',
  embeddedLoyaltyFeaturesDescription3:
    'Allow customers to seamlessly use their loyalty points as payment, enhancing the value of your rewards program at checkout. Customers can redeem points directly during their shopping journey, encouraging frequent card usage and building deeper loyalty.',
  embeddedLoyaltyFeaturesTitle4: 'Custom Shopping Portals & Offer Walls',
  embeddedLoyaltyFeaturesDescription4:
    'Offer your customers an intuitive shopping directory with exclusive deals from more than 100,000 global merchants, including travel and even meals. Whether through pre-configured solutions or customized integrations, Karma creates a hub for savings and rewards tailored to your brand, which can be hosted directly in your banking app, customer account page or behind a dedicated URL.',
  embeddedLoyaltyFeaturesTitle5: 'Targeted Cashback Offers & Notifications',
  embeddedLoyaltyFeaturesDescription5:
    'Delight customers with timely cashback notifications while they shop online. Karma’s platform presents offers at critical points in the purchase journey, increasing conversions and satisfaction. Notify customers via email, text or push notifications of price reductions or back-in-stock items for saved products and shopping lists that your customers have saved and curated.',
  embeddedLoyaltyResultsTitle: 'We Drive Results.',
  embeddedLoyaltyResultsDescription: 'Here’s how:',

  embeddedLoyaltyResultsCaption1: 'Comprehensive Merchant Network',
  embeddedLoyaltyResultsDescription1:
    'Access offers from a vast affiliate network, connecting your customers to over 100,000 global merchants.',

  embeddedLoyaltyResultsCaption2: 'Increased Engagement and Revenue',
  embeddedLoyaltyResultsDescription2:
    'By embedding rewards into your ecosystem, customers are incentivized to shop, increasing program adoption and driving incremental revenue.',

  embeddedLoyaltyResultsCaption3: 'Enhanced Customer Retention',
  embeddedLoyaltyResultsDescription3:
    'Offering meaningful savings and rewards builds loyalty, ensuring your customers stay engaged with your services.',
  embeddedLoyalty: 'Embedded Loyalty',
  headerEmbeddedLoyalty: 'Karma | Embedded Loyalty',
  headerSwe: 'Karma | SWE',
  gotKarmaStep1Title: 'Tap the <1/> on the left of <2/> the address bar. ',
  gotKarmaStep1Description: 'This is where all the magic is hidden.',
  gotKarmaStep2Title: 'Select ‘Manage Extensions’ <1/>',
  gotKarmaStep2Description: 'You’re getting warmer...',
  gotKarmaStep3Title: 'Toggle on ‘Karma’ <1/>',
  gotKarmaStep3Description: 'You found us! Now turn us on.',
  gotKarmaStep4Title: 'Tap <1/>',
  gotKarmaStep4Description: 'Just grant access - you’re so close!',
  gotKarmaStep5Title: 'Pick ‘Always Allow’ <1/>',
  gotKarmaStep5Description: 'Karma will make sure you always get the best deal.',
  gotKarmaStep6Title: 'Pick ‘Always Allow On Every Website’',
  gotKarmaStep6Description: 'Karma will find you the lowest prices everywhere.',
  downloadKarma: 'Download Karma!',
  sweQuestion1: 'How do I get the mobile extension?',
  sweAnswer1:
    'To enable the mobile extension, you have to start by downloading the app. Once you had that, just go into Safari, activate Karma, and grant access! For a more detailed explanation - look right above 🙂.',
  sweQuestion2: 'How does the Safari extension work?',
  sweAnswer2:
    "Karma automatically works in the background while you shop. It's a smart shopping companion that searches the web for coupons, deals, and lower prices. If you tell Karma what you're interested in, it will know to keep you in the loop on that specific item or offer.",
  sweQuestion3: 'Why do I need the Karma App to use the Safari Extension?',
  sweAnswer3:
    "Like other mobile extensions, the Safari extension is powered by the Karma App. They are bundled together in one download. So, if you already have the app, you're a step ahead!",
  sweQuestion4: 'Is the mobile extension available for Android?',
  sweAnswer4:
    "The mobile extension isn't available for Android yet, but the Karma App is! Get it in the Google Play Store now!",
  sweQuestion5: "Is my data secure on Karma's Safari extension?",
  sweAnswer5:
    'We take your privacy and security extremely seriously. Read more about what we do to keep your information safe.',

  sweScanBoxHeaderTitle: 'Karma for iPhone',
  sweScanBoxHeaderDescription:
    'The an all-in-one shopping assistant that automatically saves you time and money - now right at the tip of your fingers.',
  sweScanBoxTitle: 'Get Started on Mobile Safari',
  sweScanBoxDescription: 'Our extension is available exclusively in Mobile Safari.',
  sweScanBoxOpenSafari: 'Open this page in Safari on your iPhone.',
  sweScanBoxScanTheQrCode: 'Scan the QR code below to download the Karma app and activate the extension.',
  sweScanBoxOpenCamera: 'Open your camera on your iPhone to scan QR code.',
  stepsToSavingTitle: 'Got Karma?\n Let’s Walk You Through The Steps to Savings',
  discoverTopPicks: 'Discover Top Picks',
  topPicksAt: 'Top Picks at {{brand}}',
  games: 'Games',

  scheduleADemo: 'Schedule a demo',
  partnershipsReadyToShopTitle: 'Reach Millions of\nReady-to-Shop Users',
  partnershipsReadyToShopDescription: 'Tap into our engaged audience and drive real results.\nLet’s grow together.',
  partnershipsStat1Title: 'Shoppers',
  partnershipsStat2Title: 'Saved Items',
  partnershipsStat3Title: 'Newsletter Subscribers',

  partnershipsTurnShoppersTitle: 'Turn Shoppers into Buyers',
  partnershipsTurnShoppers1Title: '500K daily active users',
  partnershipsTurnShoppers3Title: 'Top Geos: US, UK, EU, CA, APAC',
  partnershipsTurnShoppers4Title: '85% of shoppers plan their next\n purchase with us',
  partnershipsTurnShoppers5Title: '$185 AOV',
  partnershipsTurnShoppers6Title: '200K+ partnered brands',

  partnershipsStrategicTitle: 'Strategic Brand Placements',
  partnershipsStrategicCaption1: 'Email Newsletter',
  partnershipsStrategicCaption2: 'Email Banner',
  partnershipsStrategicCaption3: 'Daily Featured',
  partnershipsStrategicCaption4: 'Trending Offers',
  partnershipsStrategicCaption5: 'Blog Content',
  partnershipsStrategicCaption6: 'Popular Stores',

  partnershipsExplorerTitle: 'Explore Our Case Studies',
  caseStudyTravelTitle: 'Travel',
  caseStudyTravelDescription:
    'Travel shoppers consistently generate some of the highest AOVs in ecommerce, with 65% of all bookings expected to happen online by 2026.',
  caseStudyLuxuryTitle: 'Luxury',
  caseStudyLuxuryDescription:
    'Millennials and Gen Z now drive most of the growth in luxury and are expected to represent up to 80% of global purchases by 2030.',
  caseStudyTechTitle: 'Tech',
  caseStudyTechDescription:
    'Savvy products means savvy shoppers. Electronics consumers compare hard, spend big, and respond strongly to well-timed offers.',
  caseStudyBeautyTitle: 'Beauty',
  caseStudyBeautyDescription:
    'Beauty shoppers are highly engaged, mobile-first, and influenced by social content - making this one of the most dynamic categories in ecommerce.',
  caseStudyHomeTitle: 'Home',
  caseStudyHomeDescription: 'High-consideration purchases + high AOV = every incremental sale counts.',
  caseStudyMarketplaceTitle: 'Marketplace',
  caseStudyMarketplaceDescription:
    'Around 72% of global ecommerce revenue now flows through marketplaces - brands that stand out here win visibility and scale.',
  caseStudyPetsTitle: 'Pets',
  caseStudyPetsDescription:
    'Loyalty-driven buyers who return again and again - pet owners show some of the highest repeat purchase rates across categories.',
  caseStudySportsOutdoorsTitle: 'Sports & Outdoors',
  caseStudySportsOutdoorsDescription:
    'Fitness-driven shoppers are mission-oriented and conversion-ready. Engagement spikes during key seasonal moments and product drops.',
  caseStudyFashionTitle: 'Fashion',
  caseStudyFashionDescription: '1 in 5 fashion buyers also purchase from Beauty or Home categories within 30 days.',
  partnershipsGetStartedTitle: 'Get Started Today',
  partnershipsGetStartedDescription:
    'Join a network of top brands leveraging Karma to reach millions of heavy shoppers.\n For more information contact <1>partnerships@karmanow.com</1>',
  signIn: 'Sign In',
  couponCodesPromoCodesTitle: '{{Brand}} Promo Codes & Coupons',
  couponCodesPromoCodesCardTitle: 'Unlock Real-Time {{Brand}} Promo Codes - Verified Daily',
  couponCodesPromoCodesCardDescription:
    "Karma tracks, verifies, and refreshes promo codes in real time so you never miss a deal - whether you're shopping tech, home essentials, or the latest fashion finds. Bookmark this page and check back often for fresh savings that actually work. One click, instant value, no effort.",
  couponCodesHelpTitle: 'How Karma Helps You Find the Best {{Brand}} Promo Codes',
  couponCodesHelpCard1Title: 'Why Karma is the best place for real-time promo codes',
  couponCodesHelpCard1Description:
    "Karma tracks deals in real time, ensuring you see working promo codes the moment they're available. No endless searching, no expired links—just fresh, reliable discounts curated for shoppers who want to save smart with zero hassle.",
  couponCodesHelpCard2Title: 'How We Verify Codes',
  couponCodesHelpCard2Description:
    "Every promo code on Karma is tested before it's displayed, and continuously monitored throughout the day. If a code stops working, we remove it instantly so you never waste time trying expired or misleading coupons. Our verification system keeps your savings accurate, clean, and frustration-free.",
  couponCodesHelpCard3Title: 'How to Apply {{Brand}} Promo Codes (Step-by-Step)',
  couponCodesHelpCard3Step1: 'Browse this list and choose a code you want to use',
  couponCodesHelpCard3Step2: 'Click Get Code or Copy Code',
  couponCodesHelpCard3Step3: "You'll be taken to the shop automatically",
  couponCodesHelpCard3Step4: 'Add your items to cart',
  couponCodesHelpCard3Step5: 'Paste the code into the Promo/Discount box at checkout',
  couponCodesHelpCard3Step6: 'Enjoy instant savings on your order 🎉',
  couponCodesHelpCard4Title: 'Why {{Brand}} Promo Codes Expire Quickly',
  couponCodesHelpCard4Description:
    "Discounts are time-sensitive and heavily demand-driven. Many deals are tied to inventory, flash sales, or seller promotions, meaning they can disappear within hours. That's why Karma refreshes codes around the clock, to keep you ahead of the expiration clock.",
  couponCodesHelpCard5Title: 'Other Ways to Save Money on {{Brand}}',
  couponCodesHelpCard5Description:
    'Promo codes are just one part of the savings puzzle. With Karmanow, you can also save through:',
  couponCodesHelpCard5ListItem1: 'Price-drop alerts',
  couponCodesHelpCard5ListItem2: 'Back-in-stock notifications',
  couponCodesHelpCard5ListItem3: 'Cashback and coupon stacking opportunities',
  couponCodesHelpCard5ListItem4: 'Seasonal & holiday sale tracking',
  couponCodesHelpCard5Conclusion: 'More savings → Less effort → Smarter shopping.',
  couponCodesTodaysTopTitle: "Today's Top {{Brand}} Promo Codes",
  couponCodesTodaysTrendingPromoCodes: "Today's Trending Promo Codes",
  viewMoreDeals: 'View More Deals',
  getPromoCode: 'GET PROMO CODE',
  promoCodeCopied: 'Code copied',
  neverMissADeal: 'Never miss a deal',
  subscribeToOurNewsletter: 'Subscribe to our newsletter and get notified about amazing discounts.',
  subscribing: 'Subscribing...',
  subscribe: 'Subscribe',
  newsletterSubscriptionSuccess: 'Successfully subscribed to newsletter!',
  newsletterSubscriptionError: 'Failed to subscribe. Please try again.',
  couponCodesQuestionsSubtitle: "Got questions about Karma? We've got answers.",
  couponCodesQuestionsQ1: 'How often are promo codes updated?',
  couponCodesQuestionsA1: 'We update this page daily to ensure you get the latest deals.',
  couponCodesQuestionsQ2: 'Can I use multiple promo codes?',
  couponCodesQuestionsA2:
    "Depends on the brand - some allow you to do so while others don't. But most coupons can be combined with other discounts!",
  couponCodesQuestionsQ3: 'Do promo codes expire?',
  couponCodesQuestionsA3: 'Yes, most codes have a limited time frame, so check the expiration date before using.',
  couponCodesQuestionsQ4: 'Is Karma free to use?',
  couponCodesQuestionsA4: '100% free — no sign-up required to browse codes or save money.',
  couponCodesQuestionsQ5: 'Are promo codes verified?',
  couponCodesQuestionsA5: 'Yes - Karmanow verifies codes in real time to eliminate dead or fake discounts.',
  verified: 'Verified',
  couponCodesShoppingTipsTitle: '{{Brand}} Shopping Tips',
  couponCodesShoppingTipsSubtitle: "Shopping at {{Brand}}? Here's how to save smarter:",
  couponCodesDiscountsOfDayTitle: 'What To Buy At {{Brand}} Now',
  couponCodesDiscountsOfDaySubtitle: 'Biggest Discounts of the Day',
  couponCodesDiscountsOfDayNeverMissADeal: 'Never miss a deal',
  couponCodesDiscountsOfDaySubscribeToOurNewsletter:
    'Subscribe to our newsletter and get notified about amazing discounts.',
  couponCodesDiscountsOfDaySubscribing: 'Subscribing...',
  couponCodesDiscountsOfDaySubscribe: 'Subscribe',
  couponCodesPopularBrandsTitle: 'Promo Codes From Other Popular Brands',
  couponCodesPopularBrandsSubtitle:
    'Looking for promo codes from other stores? Click on any brand to see the latest verified promo codes and savings.',
  headerKarmaEarn: 'Karma | Karma Earn',
  earnNowShopLater: 'Earn now. Shop later.',
  startEarningBtn: 'Start Earning!',
  startEarningDescription: 'Turn the things you already do into real rewards, with more ways to earn in one place.',
  giftCardSuccessTitle: "You're all set!",
  giftCardSuccessMessage: 'Your <strong>{{name}}</strong> gift card is on its way - check your inbox shortly.',
  giftCardErrorTitle: 'Something went wrong.',
  giftCardErrorMessage: "Please reach out to support and we'll get this sorted for you.",
};
